var _style, _path, _g, _path2, _path3, _path4, _g2, _polygon, _path5, _path6, _path7, _g3, _polygon2, _path8, _path9, _path10, _g4, _g5, _g6, _g7, _path11, _path12, _path13, _polygon3, _polygon4, _g8, _g9, _path14, _g10, _g11, _path15, _path16, _g12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerandenergybremove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2475 1650",
    style: {
      enableBackground: "new 0 0 2475 1650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FCF3EC;}\r\n\t.st1{fill:#BDD0FB;}\r\n\t.st2{opacity:0.47;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{fill:url(#SVGID_00000098941851428454108030000005529487554336987578_);}\r\n\t.st5{fill:#91B3FA;}\r\n\t.st6{fill:url(#SVGID_00000015340336505112692420000001445485543881065105_);}\r\n\t.st7{fill:#7D97F4;}\r\n\t.st8{fill:url(#SVGID_00000170957718413714496330000008485789152800923806_);}\r\n\t.st9{fill:url(#SVGID_00000013876613644350316840000011838430592694566537_);}\r\n\t.st10{fill:url(#SVGID_00000026882236592899672070000001506589373830244743_);}\r\n\t.st11{fill:url(#SVGID_00000060018452958544160590000001032940577953779634_);}\r\n\t.st12{fill:url(#SVGID_00000048467975968463746470000005751263075766978201_);}\r\n\t.st13{fill:url(#SVGID_00000085208824193359480550000008433666864673879990_);}\r\n\t.st14{fill:url(#SVGID_00000156587600338786220710000004371667778787517072_);}\r\n\t.st15{fill:url(#SVGID_00000065064943984327181100000015436414387382065845_);}\r\n\t.st16{fill:url(#SVGID_00000115497449775965114800000002609926023757877678_);}\r\n\t.st17{fill:url(#SVGID_00000083805308068600828240000007088611502506202301_);}\r\n\t.st18{fill:#FFFFFF;}\r\n\t.st19{fill:url(#SVGID_00000029016737327151077780000014832156762024994179_);}\r\n\t.st20{fill:url(#SVGID_00000003101944918186782380000004614228635270248071_);}\r\n\t.st21{fill:url(#SVGID_00000115475349834755020870000003615242975681454994_);}\r\n\t.st22{fill:url(#SVGID_00000139995321718554559630000014265105232076989334_);}\r\n\t.st23{fill:url(#SVGID_00000109720373626843027660000013292076918613649070_);}\r\n\t.st24{fill:url(#SVGID_00000170279556509746602610000006192488761741135788_);}\r\n\t.st25{fill:url(#SVGID_00000130611870631724538060000015673807306370669491_);}\r\n\t.st26{fill:url(#SVGID_00000018225410142571739080000007216804558230413236_);}\r\n\t.st27{fill:url(#SVGID_00000094617784790555049250000012620634770813799057_);}\r\n\t.st28{fill:url(#SVGID_00000073720220767193679210000010463652790783207336_);}\r\n\t.st29{fill:url(#SVGID_00000080170294382515548340000006663951000502421905_);}\r\n\t.st30{fill:url(#SVGID_00000085208399271697975820000007894304155862352817_);}\r\n\t.st31{fill:url(#SVGID_00000003073765130682442100000006112448130217447573_);}\r\n\t.st32{fill:url(#SVGID_00000048462990387176042170000006527352337074879623_);}\r\n\t.st33{fill:url(#SVGID_00000008114947288678616300000007612706880757899926_);}\r\n\t.st34{fill:url(#SVGID_00000172398709885026881010000007599695537107194004_);}\r\n\t.st35{fill:url(#SVGID_00000019654809085786500120000009842982036387235250_);}\r\n\t.st36{fill:url(#SVGID_00000106858236594658197050000002280467336835144327_);}\r\n\t.st37{fill:url(#SVGID_00000041295479122543386920000009006763670716408459_);}\r\n\t.st38{fill:url(#SVGID_00000060006977990567743840000006565835556029256077_);}\r\n\t.st39{fill:url(#SVGID_00000083808621913795855480000011787416614940200341_);}\r\n\t.st40{fill:url(#SVGID_00000153679053651904031260000015646493805628547508_);}\r\n\t.st41{fill:url(#SVGID_00000152970015672529840290000010176654430011039934_);}\r\n\t.st42{fill:url(#SVGID_00000094597716396809684900000009393203285604086682_);}\r\n\t.st43{fill:url(#SVGID_00000119824828549476310790000014210955934708561026_);}\r\n\t.st44{fill:url(#SVGID_00000161628715925498599980000013006287794969446835_);}\r\n\t.st45{fill:url(#SVGID_00000127745847741707483330000009579127284072576945_);}\r\n\t.st46{fill:url(#SVGID_00000008866497600182320560000007545190310340355493_);}\r\n\t.st47{fill:url(#SVGID_00000131341480856965624610000011606332892063991172_);}\r\n\t.st48{fill:url(#SVGID_00000060001024874316847230000005716225287797810563_);}\r\n\t.st49{fill:url(#SVGID_00000007412440420721175720000015573894698175724221_);}\r\n\t.st50{fill:url(#SVGID_00000101814744145933747210000003913501934426611331_);}\r\n\t.st51{fill:url(#SVGID_00000000223908720801357020000011453542374760140985_);}\r\n\t.st52{fill:url(#SVGID_00000161612710028670611910000008480013962695788947_);}\r\n\t.st53{fill:url(#SVGID_00000022542526465078760320000010107671879395542971_);}\r\n\t.st54{fill:url(#SVGID_00000153663753728499792510000011507609329092597929_);}\r\n\t.st55{fill:url(#SVGID_00000034792663882389270760000016611479012936633485_);}\r\n\t.st56{fill:url(#SVGID_00000175285530125950203190000005878615316222874266_);}\r\n\t.st57{fill:url(#SVGID_00000058561711563355197130000009066366225805168817_);}\r\n\t.st58{fill:url(#SVGID_00000077325780103063945430000017537546063598008238_);}\r\n\t.st59{fill:url(#SVGID_00000056420331899846095390000014117788967035031472_);}\r\n\t.st60{fill:url(#SVGID_00000121276534019805618110000012624700835785362575_);}\r\n\t.st61{opacity:0.5;fill:#7D97F4;enable-background:new    ;}\r\n\t.st62{fill:url(#SVGID_00000127026225474130270310000018249279416737904543_);}\r\n\t.st63{fill:url(#SVGID_00000051352310619036620460000009941838979856311450_);}\r\n\t.st64{fill:url(#SVGID_00000092452771720759079340000017418027206538321331_);}\r\n\t.st65{fill:url(#SVGID_00000149367363393503944180000002085094060235017605_);}\r\n\t.st66{fill:url(#SVGID_00000137109957933093389560000013754236924432998315_);}\r\n\t.st67{fill:url(#SVGID_00000053528836618211528000000008430147129497486245_);}\r\n\t.st68{fill:url(#SVGID_00000119801772739589726020000001979381886278444989_);}\r\n\t.st69{fill:url(#SVGID_00000003822802211382851570000012905192075721364671_);}\r\n\t.st70{fill:url(#SVGID_00000013194207960797769350000014231460192783703742_);}\r\n\t.st71{fill:url(#SVGID_00000181069153519755137390000004915669904455207356_);}\r\n\t.st72{fill:url(#SVGID_00000069399118740221315310000012365457123411126718_);}\r\n\t.st73{fill:url(#SVGID_00000009580494938741585420000001568289035560519842_);}\r\n\t.st74{fill:url(#SVGID_00000166673080661633716170000015049441271926548370_);}\r\n\t.st75{fill:url(#SVGID_00000170236124392153137350000007802313711578031525_);}\r\n\t.st76{fill:url(#SVGID_00000062185508595460355940000013344915675586773938_);}\r\n\t.st77{fill:url(#SVGID_00000132768240939618381620000002506215127951109780_);}\r\n\t.st78{fill:url(#SVGID_00000176754220926593945470000015679806760447497883_);}\r\n\t.st79{fill:url(#SVGID_00000141435130298504837460000012460920954916107954_);}\r\n\t.st80{fill:url(#SVGID_00000149361289301525674140000011214773656161610679_);}\r\n\t.st81{fill:url(#SVGID_00000115475526948486796780000004078058443729976704_);}\r\n\t.st82{fill:url(#SVGID_00000063626365323420947770000006309722625246897557_);}\r\n\t.st83{fill:url(#SVGID_00000049939803348707296990000011098835625776368535_);}\r\n\t.st84{fill:url(#SVGID_00000111879410525133669460000015396456026247291578_);}\r\n\t.st85{fill:url(#SVGID_00000048494451156000513460000000056078068748088762_);}\r\n\t.st86{fill:url(#SVGID_00000139279763114156659750000005914117798746961035_);}\r\n\t.st87{fill:url(#SVGID_00000024689692340721126270000002737191031709178253_);}\r\n\t.st88{fill:url(#SVGID_00000049187678319840260580000010347367730709672325_);}\r\n\t.st89{fill:url(#SVGID_00000057120515072770663370000002407366770517527212_);}\r\n\t.st90{fill:url(#SVGID_00000001653834545859302240000014929753026900652215_);}\r\n\t.st91{fill:url(#SVGID_00000062191557072571366290000013901976558580160165_);}\r\n\t.st92{fill:url(#SVGID_00000169550586444624119140000011860062687312576430_);}\r\n\t.st93{fill:url(#SVGID_00000042735882750329570170000006312937568143949471_);}\r\n\t.st94{fill:url(#SVGID_00000020399138345359601750000009467320613123066781_);}\r\n\t.st95{fill:url(#SVGID_00000176730241410094522730000012357848548061288350_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.7,454.1c26.2-74.6,85.8-138.1,162-161.9c110.1-34.4,231.7,12.5,342.9-28.5 c50.5-18.6,79-71.3,121.4-104.3c65.3-50.9,158-50.3,237.6-27.5s152.4,64.7,231.1,90.6c134,44.2,283.6,39.4,414.5-13.3 c57.5-23.1,111.3-55,169.8-75.4s124.8-28.3,181.3-2.8c56.5,25.5,97,92,77.4,150.8c-3.9,11.7-10,23.3-9.2,35.6 c1.3,19.8,20.4,34.2,39.7,38.6c19.3,4.4,39.4,1.5,59.2,2c88.9,2.2,168.2,83.3,168.7,172.2c0.4,73.7-45.1,138.5-84,201.1 c-38.9,62.6-73.8,137.8-50.6,207.7c13.7,41.5,45.9,74,67,112.2c54.7,99.2,25.5,230.6-50.9,314.3 c-76.4,83.7-190.8,124.7-303.6,134.4s-226.1-8.6-337.9-26.6c-111.8-18.1-225.2-36.1-338-25.7l6.1-3.3 c-220.4,54.5-451,67.5-676.2,38.3c-47.1-6.1-101.2-19.2-121.2-62.4c-16.8-36.4-1.7-79.2-5.2-119.1c-5-57.6-48.2-104.8-95.4-138.3 s-100.6-58.4-143.1-97.7c-83.1-76.8-7.4-129.2-19.8-241.6c-12.7-115.7-79-220.1-52-340C144.5,473.5,147.3,463.7,150.7,454.1z"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1590,1497.1c-2.7,0-5.1-1.8-5.9-4.4c-8-28.2-49.9-184.5-21-276.5c31.8-101.4,94.3-201.6,17.2-416.2 c-43.7-121.6-42.3-192.3-39.6-217.2c0.4-3.8,5.2-5,7.4-1.9c27.2,38.8,141.1,202.4,163.7,255.2c25.7,60.1,56.9,180.4-32,253.6 c-87.5,72-150.7,226.8-84.1,399.2C1597.3,1492.8,1594.3,1497.1,1590,1497.1L1590,1497.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1612,1497.1c-3,0-5.7-1.8-6.8-4.6c-9.9-24.5-52.1-142.9,18.2-232.5c73.3-93.5,136-109.9,144.4-161.8 c0.5-3.2,4.8-3.8,6-0.8c17.5,42.1,68.3,189.3-37.2,268.2c-104.7,78.2-118.1,108-117.3,123.9 C1619.6,1493.7,1616.2,1497.1,1612,1497.1L1612,1497.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1768.9,1140.6c-0.6,8.4-2.2,16.6-4.3,24.7c-2.1,8.1-4.7,16.1-8.1,23.8c-3.3,7.7-7.1,15.3-11.5,22.4 c-4.4,7.2-9.3,14.1-14.8,20.5s-11.4,12.5-17.9,18c-6.5,5.5-13.4,10.4-20.6,14.9l-10.7,6.3c-1.8,1-3.4,2.1-5.1,3.2 c-1.7,1.1-3.4,2.1-5,3.3c-6.7,4.5-12.9,9.6-18.7,15.1c-23.5,21.9-38.4,52.1-43.9,84c-5.8,32-3.8,65.2,2.1,97.6 c0.1,0.6-0.3,1.2-0.9,1.4c-0.6,0.1-1.2-0.3-1.3-0.9c-8.1-32.1-11.8-65.9-6.8-99.2c2.6-16.6,7.3-33.1,14.8-48.3 c7.5-15.2,17.6-29.3,29.9-41c6.1-5.9,12.7-11.3,19.7-16.1c1.7-1.3,3.5-2.4,5.3-3.5c1.8-1.2,3.6-2.3,5.4-3.3l10.7-6.2 c13.8-8.3,26.3-18.6,37.1-30.6c5.4-6,10.3-12.4,14.8-19.1c4.5-6.7,8.5-13.8,12.2-21c3.6-7.3,6.8-14.8,9.5-22.5 c2.6-7.7,4.9-15.6,6.4-23.6l0-0.1c0.1-0.5,0.6-0.9,1.1-0.8C1768.6,1139.7,1768.9,1140.2,1768.9,1140.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M716,472.9c-0.9-5-8.1-4.9-8.9,0.1c-3.7,25.2-10.9,57.4-24.2,78.5c-24.8,39-69.8,181.1,53.8,252 s154.1,108.3,153.2,244.4c-0.8,124.3,6.6,389.7,7.9,434.4c0.1,3.6,3.1,6.5,6.7,6.5l0,0c3.7,0,6.7-3,6.7-6.7 c0.2-58.2,1-481.2-9.6-583.7C884.7,736,747.8,652.8,716,472.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 707.6762,
    y1: 884.2766,
    x2: 895.6923,
    y2: 884.2766,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M717.5,580.1c-1.3,4-2.3,8.5-3,12.8c-0.4,2.2-0.6,4.4-0.9,6.6c-0.3,2.2-0.3,4.4-0.5,6.6 c-0.2,8.8,0.2,17.7,1.9,26.4c3.3,17.3,10.8,33.7,21.1,48.1c1.3,1.8,2.5,3.7,3.9,5.4l4.3,5l4.3,5l4.6,4.8 c6.3,6.4,12.9,12.4,19.7,18.4c13.5,11.9,27.7,23.3,41.1,35.8c13.4,12.4,25.9,26,36.4,41.1c5.2,7.6,10,15.5,14.3,23.6l3.1,6.2 l1.5,3.1l1.4,3.2l2.8,6.3l2.5,6.4c1.7,4.2,3,8.6,4.5,13c1.4,4.4,2.6,8.8,3.9,13.2c1.1,4.4,2.2,8.9,3.2,13.3 c0.8,4.5,1.9,8.9,2.6,13.4c3.1,18,4.8,36.1,5.7,54.3c0,1-0.7,1.8-1.7,1.9c-1,0-1.8-0.7-1.9-1.7c-2.4-36-8.3-72-21.4-105.4 l-2.5-6.2l-2.8-6.1l-1.4-3.1l-1.5-3l-3-6c-4.3-7.8-9-15.5-14.1-22.8c-5.2-7.2-10.8-14.2-16.8-20.9c-6-6.7-12.4-13-19-19.1 c-13.2-12.2-27.3-23.5-41-35.5c-6.9-6-13.6-12.1-20.1-18.7l-4.8-5l-4.5-5.3l-4.5-5.3c-1.4-1.8-2.7-3.8-4-5.7 c-10.6-15.1-18.5-32.5-21.4-50.9l-1-6.9c-0.3-2.3-0.3-4.6-0.5-6.9c-0.2-2.3-0.2-4.6-0.1-7c0-2.3,0.1-4.6,0.3-6.9 c0.2-2.3,0.4-4.6,0.8-6.9c0.3-2.3,0.7-4.6,1.2-6.8c0.9-4.6,2.2-9,3.9-13.4c0.4-1,1.5-1.5,2.5-1.1c0.9,0.4,1.4,1.4,1.1,2.3 L717.5,580.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M628.1,824.6c-2.2-4.9-9.5-4.3-10.9,0.9c-12.7,47.3-39,188.7,77.2,255.6 c140.8,81.1,144.2,44.4,161.8,187.1c15.1,122.8,20.3,197.5,21.4,216c0.2,2.5,2.2,4.5,4.8,4.5l0,0c2.7,0,4.9-2.2,4.8-4.9 c-1.3-38.7-11-294.2-38.6-419.2C799.3,842.2,684.2,948,628.1,824.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079452427316938345740000013708664694498239118_",
    gradientUnits: "userSpaceOnUse",
    x1: 628.4373,
    y1: 642.9078,
    x2: 855.4266,
    y2: 642.9078,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079452427316938345740000013708664694498239118_)"
    },
    d: "M630.5,850.5c1.2,8.1,4,16.1,7.5,23.5 c3.6,7.4,7.8,14.5,12.8,21.1c10,13.1,22.6,24.1,36.3,33.2c6.8,4.7,14.1,8.5,21.4,12.5l11.2,6c3.7,2.1,7.3,4.3,11,6.4 c14.5,8.8,28.4,18.7,41.3,29.9c12.7,11.3,24.4,23.9,34.6,37.5l7.3,10.5c1.3,1.7,2.3,3.6,3.4,5.4l3.2,5.5l3.2,5.5l2.8,5.7 c1.8,3.8,3.8,7.6,5.6,11.5c3.1,7.9,6.7,15.7,9,23.8c1.3,4.1,2.7,8.1,3.8,12.2l3,12.4l1.5,6.2l1.1,6.2l2.2,12.5 c0.4,2.1,0.6,4.2,0.8,6.3l0.7,6.3l1.3,12.6c0.1,0.7-0.4,1.3-1.1,1.3c-0.7,0.1-1.2-0.4-1.3-1l0-0.1l-1.8-12.4l-0.9-6.2 c-0.3-2.1-0.5-4.2-1-6.2l-2.5-12.3l-1.2-6.2l-1.6-6.1l-3.3-12.1c-1.2-4-2.7-7.9-4-11.8c-2.4-8-6.1-15.5-9.2-23.2 c-1.8-3.8-3.8-7.4-5.6-11.1l-2.9-5.5l-3.2-5.3l-3.2-5.3c-1.1-1.8-2.1-3.6-3.4-5.2l-7.3-10.1c-10.1-13.2-21.5-25.4-34-36.3 c-12.6-10.8-26.3-20.4-40.5-29c-3.6-2.1-7.2-4.2-10.8-6.3l-11.1-5.8c-7.4-4.1-15-8.1-22-13.1c-14.1-9.7-27-21.5-36.8-35.7 c-9.7-14.1-17-30.3-18.1-47.6c0-0.6,0.4-1.1,1-1.1c0.5,0,1,0.3,1.1,0.9L630.5,850.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M864.2,1488.7c3,0,5.3-2.7,4.8-5.6c-5-29.4-34.1-163.9-151.4-164.9c-103.9-0.9-167,51-189,72.9 c-3.9,3.9-2.2,10.6,3.2,12.1c14.2,3.9,37.8,13.4,53,35.4c22.8,33.2,82.1,28,119-17.6c36.6-45.2,127.7-72.2,155.7,63.9 C859.9,1487.1,861.9,1488.7,864.2,1488.7L864.2,1488.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M577.2,1376.1c16.3-13,34.7-23.3,54-31.2c9.7-4,19.7-7.2,29.8-9.7c10.2-2.5,20.6-4.2,31-5 c10.5-0.9,21-0.8,31.5,0.3c10.5,1.1,20.8,3.2,30.8,6.5l3.8,1.2l3.7,1.4c2.4,1,4.9,1.8,7.3,2.9c4.7,2.2,9.5,4.3,14,7.1 c9.2,5,17.6,11.3,25.6,17.8c0.5,0.4,0.5,1.1,0.2,1.5c-0.4,0.4-1,0.5-1.4,0.2l0,0c-8.5-5.8-16.9-11.6-26.2-16 c-4.5-2.4-9.3-4.2-13.9-6.3c-2.4-0.9-4.8-1.7-7.2-2.6l-3.6-1.2l-3.7-1c-9.7-2.9-19.8-4.4-29.9-5.3c-2.5-0.2-5-0.5-7.6-0.5 l-7.6-0.1c-5.1,0.2-10.1,0.3-15.2,0.8c-20.2,1.8-40,7-59.1,14c-19,7.2-37.6,16.1-55,27l0,0c-0.5,0.3-1.2,0.2-1.5-0.3 C576.7,1377.1,576.8,1376.5,577.2,1376.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "2148.6,1261.6 2156.2,917.3 2176.3,917.3 2176.3,1270.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183225478377991098400000008751635251510454171_",
    gradientUnits: "userSpaceOnUse",
    x1: 2149.1243,
    y1: 613.2545,
    x2: 2168.0071,
    y2: 278.756,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183225478377991098400000008751635251510454171_)"
    },
    d: "M2186.4,1270.8c0,5.4-2.6,9.1-5.7,9.1 h-36.6c-3.2,0-5.7-3.6-5.7-9.1l0,0c0-5.4,2.6-9.1,5.7-9.1h36.6C2183.8,1261.7,2186.4,1265.3,2186.4,1270.8L2186.4,1270.8z"
  })), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2270.9,745.6c-4-19.8-70.5,94.8-92.5,123.1c-22.1,28.2-4.9,37.1-4.9,37.1l2.9,2.7c0,0,0,0,0,0 c8.7,1.7,17.6-1.7,21.9-9.4C2218.8,862.8,2274.2,761.8,2270.9,745.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2270.3,1093.2c19.3,6-49.4-107.3-63.6-140.2s-30-21.8-30-21.8l-3.6,1.5l0,0c-6.2,6.2-7.1,16-2.5,23.5 C2192.7,991.5,2254.6,1088.3,2270.3,1093.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1968.5,952.2c-17-11,114-31,148.4-41.2c34.3-10.2,35.8,9,35.8,9l1,3.7c0,0,0,0,0,0c0,8.7-7.6,15.8-16.3,17 C2096.1,946.4,1982.3,961.2,1968.5,952.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091722519139235272760000001649463690902289795_",
    gradientUnits: "userSpaceOnUse",
    x1: 1534.6329,
    y1: 2260.8428,
    x2: 1575.0129,
    y2: 2252.6062,
    gradientTransform: "matrix(0.9359 0.3523 0.3523 -0.9359 -82.1825 2483.574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091722519139235272760000001649463690902289795_)"
    },
    d: "M2187.3,926.5 c-4,10.7-15.9,16-26.5,12c-10.6-4-16-15.9-12-26.5c4-10.7,15.9-16,26.5-12C2185.9,904,2191.3,915.9,2187.3,926.5z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2168.1,934.2c-1.8,0-3.5-0.3-5.2-1c-7.6-2.9-11.5-11.4-8.6-19.1c2.9-7.6,11.4-11.5,19.1-8.6 c3.7,1.4,6.6,4.1,8.3,7.8c1.6,3.6,1.8,7.6,0.4,11.3l0,0c-1.4,3.7-4.1,6.6-7.8,8.3C2172.2,933.7,2170.1,934.2,2168.1,934.2z  M2168.1,906.8c-5.1,0-9.9,3.1-11.8,8.1c-2.4,6.5,0.9,13.7,7.3,16.2c3.1,1.2,6.5,1.1,9.6-0.3s5.4-3.9,6.6-7l0,0 c1.2-3.1,1.1-6.5-0.3-9.6c-1.4-3-3.9-5.4-7-6.6C2171,907.1,2169.5,906.8,2168.1,906.8z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1831.6,1190.4 1840,819.8 1861.3,819.8 1861.3,1199.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119080816315728124760000012542812709758512789_",
    gradientUnits: "userSpaceOnUse",
    x1: 1855.217,
    y1: 643.1794,
    x2: 1832.5562,
    y2: 135.5849,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119080816315728124760000012542812709758512789_)"
    },
    d: "M1872.5,1199.4 c0,5.8-2.8,10.2-6.2,10.2h-39.4c-3.4,0-6.2-4.3-6.2-10.2l0,0c0-5.8,2.8-10.2,6.2-10.2h39.4 C1869.7,1189.2,1872.5,1193.5,1872.5,1199.4L1872.5,1199.4z"
  })), /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1963.6,633.9c-4.3-21.4-75.9,102.2-99.7,132.6c-23.8,30.4-5.2,39.9-5.2,39.9l3.1,2.9c0,0,0,0,0,0 c9.4,1.8,19-1.9,23.6-10.1C1907.4,760.2,1967.2,651.4,1963.6,633.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1963,1008.4c20.8,6.4-53.3-115.6-68.6-151.1c-15.3-35.4-32.3-23.5-32.3-23.5l-3.8,1.6l0,0 c-6.7,6.7-7.7,17.3-2.7,25.3C1879.4,898.8,1946,1003.2,1963,1008.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1637.8,856.5c-18.3-11.8,122.9-33.4,159.8-44.4s38.2,9.7,38.2,9.7l0.7,4c0,0,0,0,0,0 c0,9.4-7.7,17-17.1,18.3C1774.9,850.3,1652.7,866.2,1637.8,856.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037672413991208072410000008851256645357785784_",
    gradientUnits: "userSpaceOnUse",
    x1: 1203.3931,
    y1: 2242.0515,
    x2: 1246.9025,
    y2: 2233.1765,
    gradientTransform: "matrix(0.9359 0.3523 0.3523 -0.9359 -82.1825 2483.574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037672413991208072410000008851256645357785784_)"
    },
    d: "M1873.5,828.8 c-4.3,11.5-17.1,17.3-28.6,13c-11.5-4.3-17.3-17.1-12.9-28.6c4.3-11.5,17.1-17.3,28.6-13C1872,804.5,1877.8,817.3,1873.5,828.8 z"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1852.8,837c-1.9,0-3.8-0.3-5.6-1c-8.2-3.1-12.3-12.2-9.3-20.4c3.1-8.2,12.2-12.3,20.4-9.3 s12.3,12.2,9.3,20.4l0,0c-1.5,4-4.4,7.1-8.3,8.9C1857.2,836.5,1855,837,1852.8,837z M1852.8,807.5c-5.5,0-10.7,3.4-12.7,8.8 c-2.6,7,0.9,14.9,7.9,17.5c3.4,1.3,7.1,1.2,10.4-0.3s5.8-4.2,7.1-7.6l0,0c1.3-3.4,1.2-7.1-0.3-10.4s-4.2-5.8-7.6-7.1 C1856,807.8,1854.4,807.5,1852.8,807.5z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145028729092796582270000003214345953274855319_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.1884,
    y1: 1708.8207,
    x2: 477.1882,
    y2: 1312.8201,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000145028729092796582270000003214345953274855319_)"
    },
    cx: 497.6,
    cy: 456.3,
    r: 112.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053511193703031623300000003992454198328646033_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.1552,
    y1: 1725.9852,
    x2: 577.1548,
    y2: 1329.9857,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053511193703031623300000003992454198328646033_)"
    },
    d: "M612.4,539c-0.4,0-0.9-0.1-1.3-0.4 c-1-0.7-1.3-2.1-0.6-3.2c1-1.5,2-3.1,3-4.7c0.7-1.1,2-1.4,3.1-0.7c1.1,0.7,1.4,2,0.7,3.1c-1,1.6-2,3.2-3.1,4.8 C613.9,538.7,613.2,539,612.4,539z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118376810961818346660000004587876189901519768_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.8408,
    y1: 1704.8101,
    x2: 453.8405,
    y2: 1308.8105,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118376810961818346660000004587876189901519768_)"
    },
    d: "M497.7,600l-1.3,0 c-1.2,0-2.3-1-2.2-2.3c0-1.2,1-2.3,2.3-2.2l1.3,0c3.3,0,6.6-0.1,9.9-0.4c1.3-0.1,2.3,0.8,2.4,2.1c0.1,1.2-0.9,2.3-2.1,2.4 C504.5,599.9,501.1,600,497.7,600z M485,599.4c-0.1,0-0.1,0-0.2,0c-3.8-0.3-7.7-0.9-11.5-1.5c-1.2-0.2-2.1-1.4-1.8-2.6 s1.4-2,2.6-1.8c3.7,0.6,7.4,1.1,11.1,1.5c1.2,0.1,2.2,1.2,2,2.5C487.2,598.5,486.2,599.4,485,599.4z M519,598.3 c-1.1,0-2.1-0.8-2.2-1.9c-0.2-1.2,0.7-2.4,1.9-2.6c3.7-0.6,7.4-1.3,11-2.2c1.2-0.3,2.4,0.5,2.7,1.7c0.3,1.2-0.5,2.4-1.7,2.7 c-3.7,0.9-7.5,1.7-11.3,2.2C519.3,598.3,519.2,598.3,519,598.3z M462.6,595.5c-0.2,0-0.4,0-0.6-0.1c-3.7-1-7.4-2.1-11.1-3.4 c-1.2-0.4-1.8-1.7-1.4-2.9c0.4-1.2,1.7-1.8,2.9-1.4c3.5,1.2,7.1,2.3,10.7,3.2c1.2,0.3,1.9,1.5,1.6,2.8 C464.6,594.8,463.6,595.5,462.6,595.5z M541.2,593c-1,0-1.8-0.6-2.2-1.6c-0.4-1.2,0.2-2.5,1.4-2.9c3.5-1.2,7-2.5,10.5-4 c1.2-0.5,2.5,0,3,1.2s0,2.5-1.2,3c-3.5,1.5-7.2,2.9-10.8,4.1C541.6,593,541.4,593,541.2,593z M441.2,588 c-0.3,0-0.6-0.1-0.9-0.2c-3.5-1.6-7-3.3-10.4-5.1c-1.1-0.6-1.5-2-0.9-3.1c0.6-1.1,2-1.5,3.1-0.9c3.3,1.8,6.6,3.5,10,5 c1.1,0.5,1.7,1.8,1.1,3C442.9,587.5,442.1,588,441.2,588z M562.1,584.1c-0.8,0-1.6-0.4-2-1.2c-0.6-1.1-0.2-2.5,1-3.1 c3.3-1.7,6.5-3.6,9.7-5.6c1.1-0.7,2.5-0.4,3.1,0.7c0.7,1.1,0.4,2.5-0.7,3.1c-3.2,2.1-6.6,4-10,5.8 C562.8,584,562.4,584.1,562.1,584.1z M421.3,577.1c-0.4,0-0.9-0.1-1.2-0.4c-3.2-2.1-6.4-4.4-9.4-6.8c-1-0.8-1.2-2.2-0.4-3.2 c0.8-1,2.2-1.2,3.2-0.4c2.9,2.3,6,4.5,9.1,6.5c1,0.7,1.3,2.1,0.6,3.1C422.7,576.8,422,577.1,421.3,577.1z M581.2,571.9 c-0.7,0-1.4-0.3-1.8-0.9c-0.8-1-0.6-2.4,0.4-3.2c0.5-0.4,1.1-0.8,1.6-1.2c2.4-1.9,4.8-3.9,7-5.9c0.9-0.8,2.4-0.8,3.2,0.2 s0.8,2.4-0.2,3.2c-2.3,2.1-4.8,4.1-7.3,6.1c-0.5,0.4-1.1,0.8-1.7,1.3C582.2,571.8,581.7,571.9,581.2,571.9z M403.4,563.1 c-0.5,0-1.1-0.2-1.5-0.6c-2.8-2.6-5.5-5.4-8.1-8.2c-0.8-0.9-0.8-2.4,0.1-3.2c0.9-0.8,2.4-0.8,3.2,0.1c2.5,2.8,5.2,5.4,7.9,7.9 c0.9,0.8,1,2.3,0.1,3.2C404.6,562.8,404,563.1,403.4,563.1z M598.2,556.8c-0.6,0-1.1-0.2-1.6-0.6c-0.9-0.9-0.9-2.3-0.1-3.2 c2.6-2.7,5-5.5,7.4-8.4c0.8-1,2.2-1.1,3.2-0.3c1,0.8,1.1,2.2,0.3,3.2c-2.4,3-5,5.9-7.6,8.7 C599.4,556.5,598.8,556.8,598.2,556.8z M388.1,546.3c-0.7,0-1.4-0.3-1.8-0.9c-2.4-3-4.6-6.2-6.7-9.4c-0.7-1-0.4-2.5,0.7-3.1 c1-0.7,2.5-0.4,3.1,0.7c2,3.1,4.2,6.2,6.5,9.1c0.8,1,0.6,2.4-0.4,3.2C389,546.1,388.6,546.3,388.1,546.3z M375.7,527.3 c-0.8,0-1.6-0.4-2-1.2c-1.8-3.4-3.5-6.9-5.1-10.4c-0.5-1.2,0-2.5,1.2-3c1.1-0.5,2.5,0,3,1.2c1.5,3.4,3.1,6.8,4.9,10 c0.6,1.1,0.2,2.5-0.9,3.1C376.4,527.2,376,527.3,375.7,527.3z M366.5,506.5c-0.9,0-1.8-0.6-2.1-1.5c-1.2-3.6-2.4-7.4-3.3-11.1 c-0.3-1.2,0.4-2.5,1.6-2.8c1.2-0.3,2.5,0.4,2.8,1.6c0.9,3.6,2,7.2,3.2,10.7c0.4,1.2-0.2,2.5-1.4,2.9 C367,506.4,366.8,506.5,366.5,506.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047019335157352878210000012400900351879263113_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.1579,
    y1: 1685.288,
    x2: 340.1574,
    y2: 1289.2891,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047019335157352878210000012400900351879263113_)"
    },
    d: "M360.9,484.3c-1.1,0-2-0.8-2.2-1.9 c-0.3-1.9-0.6-3.8-0.8-5.7c-0.1-1.2,0.7-2.4,2-2.5c1.2-0.2,2.4,0.7,2.5,2c0.2,1.8,0.5,3.7,0.8,5.5c0.2,1.2-0.6,2.4-1.9,2.6 C361.2,484.3,361,484.3,360.9,484.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021832323076887994650000006510467303209236396_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.2268,
    y1: 1693.0271,
    x2: 385.2262,
    y2: 1297.0292,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021832323076887994650000006510467303209236396_)"
    },
    d: "M386.3,373.8c-0.5,0-0.9-0.1-1.4-0.5 c-1-0.8-1.2-2.2-0.5-3.2c1.1-1.5,2.3-3,3.5-4.5c0.8-1,2.2-1.1,3.2-0.3c1,0.8,1.1,2.2,0.3,3.2c-1.2,1.5-2.3,2.9-3.4,4.4 C387.7,373.4,387,373.8,386.3,373.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157988233035473907980000010506591186456791946_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.9648,
    y1: 1713.5892,
    x2: 504.9645,
    y2: 1317.5891,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157988233035473907980000010506591186456791946_)"
    },
    d: "M633.4,428.6c-1.1,0-2-0.7-2.2-1.8 c-0.7-3.6-1.6-7.2-2.6-10.7c-0.3-1.2,0.3-2.5,1.5-2.8s2.5,0.4,2.8,1.5c1,3.6,2,7.3,2.7,11c0.2,1.2-0.5,2.4-1.8,2.7 C633.7,428.6,633.6,428.6,633.4,428.6z M627.2,407.2c-0.9,0-1.8-0.6-2.1-1.5c-1.3-3.4-2.8-6.8-4.3-10.1 c-0.5-1.1-0.1-2.5,1.1-3c1.1-0.5,2.5-0.1,3,1.1c1.6,3.4,3.1,6.9,4.5,10.5c0.4,1.2-0.1,2.5-1.3,2.9 C627.7,407.1,627.5,407.2,627.2,407.2z M617.6,387c-0.8,0-1.5-0.4-2-1.1c-1.8-3.2-3.8-6.3-5.9-9.3c-0.7-1-0.5-2.4,0.6-3.1 s2.4-0.5,3.2,0.6c2.2,3.1,4.2,6.3,6.1,9.6c0.6,1.1,0.3,2.5-0.8,3.1C618.4,386.9,618,387,617.6,387z M604.8,368.6 c-0.7,0-1.3-0.3-1.8-0.8c-2.3-2.8-4.8-5.6-7.3-8.2c-0.9-0.9-0.8-2.3,0.1-3.2c0.9-0.9,2.3-0.8,3.2,0.1c2.6,2.7,5.2,5.6,7.5,8.5 c0.8,1,0.7,2.4-0.3,3.2C605.9,368.4,605.3,368.6,604.8,368.6z M397.1,360.9c-0.6,0-1.1-0.2-1.6-0.6c-0.9-0.9-0.9-2.3-0.1-3.2 c2.6-2.7,5.4-5.4,8.2-7.9c0.9-0.8,2.4-0.8,3.2,0.2c0.8,0.9,0.8,2.4-0.2,3.2c-2.7,2.4-5.4,5-7.9,7.7 C398.3,360.6,397.7,360.9,397.1,360.9z M589.4,352.5c-0.5,0-1.1-0.2-1.5-0.6c-2.7-2.4-5.6-4.8-8.5-7c-1-0.8-1.2-2.2-0.5-3.2 s2.2-1.2,3.2-0.5c3,2.3,6,4.7,8.8,7.2c0.9,0.8,1,2.3,0.2,3.2C590.6,352.2,590,352.5,589.4,352.5z M413.8,346 c-0.7,0-1.4-0.3-1.8-0.9c-0.8-1-0.6-2.4,0.4-3.2c3-2.3,6.1-4.5,9.3-6.5c1-0.7,2.5-0.4,3.1,0.7c0.7,1,0.4,2.5-0.7,3.1 c-3.1,2-6.1,4.1-9,6.3C414.8,345.8,414.3,346,413.8,346z M571.5,339c-0.4,0-0.8-0.1-1.2-0.4c-3.1-2-6.3-3.8-9.5-5.5 c-1.1-0.6-1.5-2-1-3.1c0.6-1.1,2-1.5,3.1-1c3.3,1.7,6.7,3.6,9.9,5.7c1.1,0.7,1.4,2.1,0.7,3.1C573,338.7,572.2,339,571.5,339z  M432.7,333.9c-0.8,0-1.6-0.4-2-1.2c-0.6-1.1-0.2-2.5,0.9-3.1c3.3-1.8,6.8-3.4,10.2-4.9c1.1-0.5,2.5,0,3,1.2s0,2.5-1.2,3 c-3.4,1.5-6.7,3-9.9,4.8C433.4,333.8,433,333.9,432.7,333.9z M551.7,328.7c-0.3,0-0.6-0.1-0.9-0.2c-3.4-1.4-6.8-2.7-10.3-3.9 c-1.2-0.4-1.8-1.7-1.4-2.9c0.4-1.2,1.7-1.8,2.9-1.4c3.6,1.2,7.2,2.5,10.6,4c1.2,0.5,1.7,1.8,1.2,3 C553.4,328.2,552.5,328.7,551.7,328.7z M453.2,325c-0.9,0-1.8-0.6-2.1-1.5c-0.4-1.2,0.2-2.5,1.4-2.9c3.6-1.2,7.2-2.3,10.9-3.2 c1.2-0.3,2.4,0.4,2.8,1.6c0.3,1.2-0.4,2.5-1.6,2.8c-3.5,0.9-7.1,1.9-10.6,3.1C453.7,325,453.4,325,453.2,325z M530.4,321.7 c-0.2,0-0.4,0-0.5-0.1c-3.6-0.9-7.2-1.6-10.8-2.2c-1.2-0.2-2.1-1.4-1.9-2.6c0.2-1.2,1.3-2.1,2.6-1.9c3.7,0.6,7.5,1.4,11.2,2.2 c1.2,0.3,2,1.5,1.7,2.7C532.4,321,531.5,321.7,530.4,321.7z M474.9,319.6c-1.1,0-2-0.8-2.2-1.9c-0.2-1.2,0.6-2.4,1.9-2.6 c3.7-0.6,7.5-1.1,11.3-1.4c1.2-0.1,2.3,0.8,2.5,2.1c0.1,1.2-0.8,2.3-2.1,2.5c-3.6,0.3-7.3,0.8-10.9,1.4 C475.1,319.6,475,319.6,474.9,319.6z M508.4,318.2c-0.1,0-0.1,0-0.2,0c-3.5-0.3-7.1-0.4-10.7-0.4h-0.3c-1.2,0-2.3-1-2.3-2.3 c0-1.2,1-2.3,2.3-2.3h0.3c3.7,0,7.4,0.1,11,0.4c1.2,0.1,2.2,1.2,2.1,2.4C510.5,317.3,509.5,318.2,508.4,318.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080185546102911329020000003301232271056687805_",
    gradientUnits: "userSpaceOnUse",
    x1: 545.7348,
    y1: 1732.2699,
    x2: 613.7347,
    y2: 1336.2684,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080185546102911329020000003301232271056687805_)"
    },
    d: "M635.8,445.5c-1.2,0-2.2-0.9-2.3-2.1 c-0.1-1.9-0.3-3.7-0.5-5.5c-0.2-1.2,0.7-2.4,2-2.5c1.2-0.1,2.4,0.7,2.5,2c0.2,1.9,0.4,3.8,0.6,5.7c0.1,1.2-0.8,2.3-2.1,2.4 C635.9,445.4,635.8,445.5,635.8,445.5z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1844.9,612.6c-0.7,0-1.4-0.2-2-0.6c-1.4-0.9-1.9-3.3-1.8-4.7l4.4-43.6h-8.8c-2.1,0-3-1.5-3.7-2.9 l-0.2-0.2c-0.6-1.2-0.9-2.1-0.5-3.7l11-43c0.4-1.6,1.6-2.1,2.6-2.1c0.9,0,1.6,0,2.1,0.3c0,0,0.1-0.4,0.1-0.4h36.9 c0,0,0,0.5,0,0.5c0.4-0.4,1.2-0.9,2.3-0.9c0.8,0,1.9,0.6,2.4,1.9c0.6,1.5,0.6,2.3-0.2,3.7l-0.1,0.2l-14.1,27.1 c-0.2,0.5-0.2,1.9,0,2.5c0.2,0.4,0.5,1.2,0.8,1.2h6c-0.1,0,0,0.5,0.1,0.5c0.4-0.2,0.9-0.1,1.6-0.1c1,0,2.2,0.7,2.7,2.2 c0.6,2,0.2,3.2-0.7,4.6l-38.2,56.1C1847,612.1,1846,612.6,1844.9,612.6z M1847.1,559.3c0.9,0,1.8,0.8,2.3,1.6 c0.9,0.8,1,1.9,0.9,2.8l-4.3,41.2l35.4-52.5h-6c-2.4,0-3.5-2.2-4.2-4c-0.7-1.7-0.7-5.4,0.2-7.1l12.9-25.1h-36.6 c-0.2,0-0.4,0.5-0.6,0.5l-10.6,41.3c-0.1,0.2-0.2,0.4-0.2,0.4v0.1c0,0,0.2,0.1,0.3,0.4c0.1,0.2,0.3-0.2,0.4,0.1 c0.1,0.2,0.3,0.3,0.5,0.3h7.8C1845.9,559.2,1846.4,559.3,1847.1,559.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1923.4,600.4c-0.5,0-0.9-0.1-1.3-0.4c-1-0.7-1.2-2.2-0.5-3.2c1.1-1.5,2.1-3,3.1-4.6 c0.7-1.1,2.1-1.4,3.1-0.7c1.1,0.7,1.4,2,0.7,3.1c-1,1.7-2.1,3.3-3.2,4.8C1924.8,600,1924.1,600.4,1923.4,600.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1863.2,631.7c-1.2,0-2.2-1-2.3-2.2c0-1.2,1-2.3,2.2-2.3c3.8-0.1,7.6-0.4,11.3-1.1 c1.2-0.2,2.4,0.6,2.6,1.8s-0.6,2.4-1.8,2.6C1871.3,631.2,1867.2,631.6,1863.2,631.7C1863.2,631.7,1863.2,631.7,1863.2,631.7z  M1851.5,631c-0.1,0-0.2,0-0.3,0c-4-0.5-7.9-1.4-11.8-2.6c-1.2-0.4-1.9-1.6-1.5-2.8s1.6-1.9,2.8-1.5 c3.6,1.1,7.4,1.9,11.1,2.4c1.2,0.2,2.1,1.3,1.9,2.5C1853.6,630.2,1852.6,631,1851.5,631z M1886.2,627.7 c-0.9,0-1.8-0.6-2.2-1.5c-0.4-1.2,0.2-2.5,1.4-2.9c3.6-1.2,7.1-2.7,10.4-4.5c1.1-0.6,2.5-0.2,3.1,1c0.6,1.1,0.2,2.5-1,3.1 c-3.6,1.9-7.3,3.5-11.1,4.7C1886.7,627.7,1886.4,627.7,1886.2,627.7z M1829.1,624.3c-0.3,0-0.7-0.1-1-0.2 c-3.6-1.7-7.1-3.8-10.4-6c-1-0.7-1.3-2.1-0.6-3.2c0.7-1,2.1-1.3,3.2-0.6c3.1,2.1,6.4,4,9.8,5.7c1.1,0.5,1.6,1.9,1.1,3 C1830.8,623.8,1830,624.3,1829.1,624.3z M1906.9,616.9c-0.7,0-1.4-0.3-1.8-0.9c-0.7-1-0.5-2.4,0.5-3.2 c0.6-0.4,1.1-0.8,1.7-1.3c2.4-1.9,4.8-4,6.9-6.2c0.9-0.9,2.3-0.9,3.2,0s0.9,2.3,0,3.2c-2.3,2.3-4.8,4.5-7.4,6.5 c-0.6,0.5-1.2,0.9-1.8,1.3C1907.8,616.8,1907.4,616.9,1906.9,616.9z M1809.9,611.1c-0.6,0-1.1-0.2-1.6-0.6 c-2.9-2.7-5.6-5.7-8.1-8.9c-0.8-1-0.6-2.4,0.4-3.2c1-0.8,2.4-0.6,3.2,0.4c2.3,3,4.9,5.8,7.7,8.4c0.9,0.9,1,2.3,0.1,3.2 C1811.1,610.9,1810.5,611.1,1809.9,611.1z M1795.5,592.7c-0.8,0-1.6-0.4-2-1.2c-2-3.5-3.7-7.2-5.1-11 c-0.4-1.2,0.2-2.5,1.3-2.9c1.2-0.4,2.5,0.2,2.9,1.3c1.3,3.5,2.9,7,4.8,10.3c0.6,1.1,0.2,2.5-0.9,3.1 C1796.2,592.6,1795.9,592.7,1795.5,592.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1787.4,570.8c-1.1,0-2-0.7-2.2-1.8c-0.4-1.9-0.7-3.8-0.9-5.8c-0.2-1.2,0.7-2.4,2-2.5 c1.2-0.2,2.4,0.7,2.5,2c0.2,1.8,0.5,3.6,0.9,5.4c0.2,1.2-0.6,2.4-1.8,2.7C1787.7,570.7,1787.5,570.8,1787.4,570.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1800.8,510.4c-0.5,0-0.9-0.1-1.3-0.5c-1-0.8-1.2-2.2-0.5-3.2c1.2-1.5,2.4-3.1,3.7-4.5 c0.8-0.9,2.2-1,3.2-0.2c0.9,0.8,1.1,2.2,0.2,3.2c-1.2,1.4-2.3,2.8-3.4,4.3C1802.2,510.1,1801.5,510.4,1800.8,510.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1934.4,532.8c-1,0-1.9-0.6-2.2-1.6c-1.1-3.5-2.5-7-4.2-10.4c-0.6-1.1-0.1-2.5,1-3c1.1-0.5,2.5-0.1,3,1 c1.8,3.5,3.2,7.2,4.4,11c0.4,1.2-0.3,2.5-1.5,2.8C1934.8,532.8,1934.6,532.8,1934.4,532.8z M1924.2,512.2 c-0.7,0-1.4-0.3-1.9-1c-0.8-1.1-1.5-2.1-2.3-3.2c-1.5-1.9-3.1-3.7-4.7-5.5c-0.9-0.9-0.8-2.3,0.1-3.2c0.9-0.9,2.3-0.8,3.2,0.1 c1.8,1.8,3.4,3.8,5,5.8c0.9,1.1,1.7,2.2,2.5,3.4c0.7,1,0.5,2.4-0.6,3.1C1925.1,512.1,1924.7,512.2,1924.2,512.2z  M1812.6,497.9c-0.6,0-1.3-0.3-1.7-0.8c-0.8-1-0.7-2.4,0.2-3.2c0.9-0.7,1.7-1.5,2.7-2.2c2.2-1.7,4.6-3.4,6.9-4.8 c1.1-0.7,2.5-0.3,3.1,0.7s0.3,2.5-0.7,3.1c-2.2,1.4-4.4,2.9-6.5,4.6c-0.8,0.7-1.7,1.3-2.5,2 C1813.6,497.7,1813.1,497.9,1812.6,497.9z M1908.4,495.6c-0.5,0-1-0.1-1.4-0.5c-2.9-2.3-6.1-4.3-9.3-6.1 c-1.1-0.6-1.5-2-0.9-3.1c0.6-1.1,2-1.5,3.1-0.9c3.4,1.9,6.8,4.1,9.9,6.5c1,0.8,1.2,2.2,0.4,3.2 C1909.7,495.3,1909.1,495.6,1908.4,495.6z M1832.1,485.8c-0.9,0-1.7-0.5-2.1-1.4c-0.5-1.1,0-2.5,1.2-3 c3.6-1.5,7.4-2.8,11.2-3.8c1.2-0.3,2.4,0.4,2.8,1.6s-0.4,2.5-1.6,2.8c-3.6,0.9-7.2,2.1-10.6,3.6 C1832.7,485.7,1832.4,485.8,1832.1,485.8z M1888.3,484.4c-0.3,0-0.5,0-0.8-0.1c-3.5-1.3-7.1-2.3-10.7-3.1 c-1.2-0.2-2-1.5-1.8-2.7c0.2-1.2,1.4-2,2.7-1.8c3.9,0.8,7.7,1.9,11.4,3.3c1.2,0.4,1.8,1.7,1.3,2.9 C1890.1,483.9,1889.2,484.4,1888.3,484.4z M1854.3,480.1c-1.2,0-2.1-0.9-2.2-2c-0.1-1.2,0.8-2.4,2-2.5 c3.9-0.4,7.9-0.5,11.9-0.3c1.2,0.1,2.2,1.1,2.1,2.4s-1.1,2.2-2.4,2.1c-3.7-0.2-7.5-0.1-11.2,0.3 C1854.5,480,1854.4,480.1,1854.3,480.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1937.6,549.7c-1.2,0-2.2-0.9-2.3-2.1c-0.1-1.8-0.3-3.7-0.6-5.5c-0.2-1.2,0.7-2.4,1.9-2.6 c1.2-0.2,2.4,0.7,2.6,1.9c0.3,1.9,0.5,3.9,0.7,5.8c0.1,1.2-0.8,2.3-2.1,2.4C1937.8,549.7,1937.7,549.7,1937.6,549.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2103.4,758.7c-0.6,0-1.2-0.2-1.8-0.6c-1.3-0.8-1.7-3-1.6-4.2l3-29.3h-5.7c-2.1,0-2.7-1.5-3.2-3.4 c-0.1-0.3-0.2-0.4-0.3-0.6c-0.6-1.1-0.7-2-0.4-3.2l8.3-32.5c0.4-1.4,1.5-2.4,2.4-2.4c1.4,0,2.1,1.3,2.5,1.3h26.4 c0.4,0,1-2.3,2.6-2.3h1.6l0.7,2.2l0.9,2.1l-1.2,1.2l-10.6,20.1c-0.1,0.2-0.1,0.9,0,1.2c0.1,0.2,0.2,0.4,0.4,0.4h3.9 c0.4,0,0.9,0.1,1.5,0.1c0.9,0,2.1,0.8,2.5,2.2c0.5,1.7,0.2,2.8-0.6,4l-28.8,42.2C2105.2,758.2,2104.4,758.7,2103.4,758.7z  M2105.7,717.8h1l1.4,2l-0.1,1.3l-3,28.8l24.7-36.7h-3.4c-2.2,0-3.1-1.8-3.7-3.3c-0.5-1.3-0.5-4.3,0.2-5.7l8.3-16h-25.6 c-0.1,0-0.2,0.5-0.3,0.5l-7.4,29.5c0.2,0.6,0.4,0.7,0.6,1.4c0.1,0.2,0.1,0.2,0.2,0.2h4.2c0.2,0,0.4-0.2,0.8-0.6l0.2-1.3 L2105.7,717.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2161.6,750.6c-0.5,0-1-0.2-1.4-0.5c-1-0.8-1.2-2.2-0.4-3.2c1.1-1.4,2.1-2.9,3.1-4.5 c0.7-1.1,2.1-1.4,3.1-0.7c1.1,0.7,1.4,2,0.7,3.1c-1,1.7-2.2,3.3-3.3,4.8C2163,750.3,2162.3,750.6,2161.6,750.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2121.6,772.8c-1.2,0-2.1-0.9-2.2-2c-0.1-1.2,0.8-2.3,2-2.5c3.8-0.3,7.5-1.1,11.1-2.2 c1.2-0.4,2.5,0.3,2.8,1.5c0.4,1.2-0.3,2.5-1.5,2.8c-3.9,1.2-7.9,2-12,2.4C2121.7,772.8,2121.7,772.8,2121.6,772.8z  M2109.8,772.7c-0.1,0-0.2,0-0.2,0c-4.1-0.5-8.1-1.3-11.9-2.6c-1.2-0.4-1.8-1.7-1.4-2.9c0.4-1.2,1.7-1.8,2.9-1.5 c3.6,1.2,7.3,2,11,2.4c1.2,0.1,2.1,1.3,2,2.5C2112,771.9,2111,772.7,2109.8,772.7z M2143.9,765.9c-0.8,0-1.6-0.4-2-1.2 c-0.6-1.1-0.2-2.5,0.9-3.1c2.5-1.4,4.9-3,7.2-4.7c0.7-0.6,1.4-1.1,2.1-1.7c0.9-0.8,2.4-0.7,3.2,0.2s0.7,2.4-0.2,3.2 c-0.7,0.6-1.5,1.3-2.3,1.9c-2.4,1.9-5.1,3.6-7.7,5.1C2144.7,765.8,2144.3,765.9,2143.9,765.9z M2087.6,765.5 c-0.4,0-0.8-0.1-1.1-0.3c-3.5-2-6.9-4.4-9.9-7.2c-0.9-0.8-1-2.3-0.2-3.2s2.3-1,3.2-0.2c2.8,2.5,5.9,4.7,9.1,6.6 c1.1,0.6,1.5,2,0.8,3.1C2089.2,765,2088.4,765.5,2087.6,765.5z M2070.2,749.9c-0.7,0-1.4-0.3-1.8-0.9 c-2.4-3.3-4.5-6.8-6.2-10.5c-0.5-1.1,0-2.5,1.1-3c1.1-0.5,2.5,0,3,1.1c1.6,3.4,3.5,6.7,5.8,9.7c0.7,1,0.5,2.4-0.5,3.2 C2071.1,749.7,2070.7,749.9,2070.2,749.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2060.4,728.6c-1,0-2-0.7-2.2-1.8c-0.4-1.9-0.8-3.8-1-5.8c-0.2-1.2,0.7-2.4,2-2.5c1.2-0.2,2.4,0.7,2.5,2 c0.2,1.8,0.5,3.6,0.9,5.4c0.3,1.2-0.5,2.4-1.7,2.7C2060.7,728.6,2060.6,728.6,2060.4,728.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2070.2,681.8c-0.5,0-0.9-0.2-1.4-0.5c-1-0.8-1.2-2.2-0.5-3.2c1.2-1.6,2.4-3.1,3.7-4.5 c0.8-0.9,2.3-1,3.2-0.2c0.9,0.8,1,2.3,0.1,3.2c-1.2,1.3-2.4,2.8-3.5,4.2C2071.6,681.5,2070.9,681.8,2070.2,681.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2169.3,694.6c-0.9,0-1.8-0.5-2.1-1.4c-1.4-3.4-3.1-6.7-5.1-9.8c-0.7-1-0.4-2.5,0.6-3.1 c1-0.7,2.4-0.4,3.1,0.6c2.2,3.3,4.1,6.9,5.6,10.6c0.5,1.2-0.1,2.5-1.3,3C2169.9,694.6,2169.6,694.6,2169.3,694.6z  M2156.6,675.4c-0.6,0-1.2-0.2-1.6-0.7c-2.6-2.6-5.5-5-8.6-7c-1.1-0.7-1.3-2.1-0.6-3.1c0.7-1,2.1-1.3,3.1-0.7 c3.3,2.2,6.5,4.8,9.3,7.6c0.9,0.9,0.9,2.3,0,3.2C2157.8,675.2,2157.2,675.4,2156.6,675.4z M2082.4,669.7 c-0.7,0-1.4-0.3-1.8-0.9c-0.7-1-0.5-2.4,0.5-3.2c3.2-2.4,6.7-4.4,10.4-6.1c1.1-0.5,2.5,0,3,1.1s0,2.5-1.1,3 c-3.4,1.5-6.6,3.4-9.6,5.6C2083.4,669.6,2082.9,669.7,2082.4,669.7z M2137.4,662.8c-0.3,0-0.6,0-0.8-0.2 c-3.4-1.4-7-2.4-10.7-3c-1.2-0.2-2.1-1.4-1.8-2.6s1.4-2,2.6-1.8c3.9,0.7,7.8,1.8,11.5,3.3c1.2,0.5,1.7,1.8,1.3,2.9 C2139.2,662.2,2138.3,662.8,2137.4,662.8z M2103.3,660.1c-1,0-2-0.7-2.2-1.8c-0.3-1.2,0.5-2.4,1.7-2.7 c3.9-0.9,7.9-1.4,11.9-1.5c1.2-0.1,2.3,1,2.3,2.2s-1,2.3-2.2,2.3c-3.7,0.1-7.4,0.5-11,1.4 C2103.7,660.1,2103.5,660.1,2103.3,660.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2173.2,711.4c-1.2,0-2.2-0.9-2.3-2.1c-0.1-1.8-0.4-3.6-0.7-5.4c-0.2-1.2,0.6-2.4,1.8-2.6 c1.2-0.2,2.4,0.6,2.6,1.8c0.3,1.9,0.6,3.9,0.8,5.8c0.1,1.2-0.8,2.3-2.1,2.4C2173.3,711.4,2173.3,711.4,2173.2,711.4z"
  }))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1994.7,1012.4c-0.7,0-1.4-0.3-1.9-1c-0.7-1-0.4-2.4,0.6-3.2c12.4-8.5,27.9-19,44.6-19c0,0,0.1,0,0.1,0 c9.5,0,18.2,3.4,26.6,6.7c6.4,2.5,13,5.1,19.7,6.1c9.8,1.4,17.9-2.2,26.6-6c3.9-1.7,7.9-3.4,12.1-4.8c16.9-5.3,31.5-6.5,43.5-3.4 c6.3,1.6,11.7,4.6,17,7.5c6,3.3,11.7,6.5,18.7,7.7c24.9,4.6,59.4,1.5,76.3-16.1c0.9-0.9,2.3-0.9,3.2-0.1s0.9,2.3,0.1,3.2 c-18.2,18.9-53.4,22.4-80.4,17.5c-7.7-1.4-14-4.9-20.1-8.2c-5.2-2.9-10.2-5.6-15.9-7.1c-11.2-2.9-25-1.8-41,3.3 c-4,1.3-7.9,3-11.7,4.6c-8.9,3.8-18,7.8-29.1,6.3c-7.3-1-14.1-3.7-20.8-6.3c-8.4-3.3-16.3-6.4-24.9-6.4c0,0-0.1,0-0.1,0 c-15.3,0-30.2,10.1-42.1,18.2C1995.6,1012.2,1995.1,1012.4,1994.7,1012.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2208.1,1036.7c-6.4,0-11.5-0.3-14.7-0.6c-11.2-0.9-21.3-5.3-31.1-9.7c-10.7-4.7-20.9-9.2-32.1-9.2 c-0.1,0-0.2,0-0.3,0c-10.9,0.1-20.5,3.7-30.6,7.5c-5,1.9-10.2,3.8-15.5,5.3c-20.6,5.7-41.1-1.7-56.7-8.8c-1.1-0.5-1.6-1.9-1.1-3 s1.9-1.6,3-1.1c14.9,6.8,34.4,13.9,53.6,8.6c5.1-1.4,10.2-3.3,15.1-5.2c10.1-3.8,20.5-7.7,32.2-7.8c12.2-0.1,23.4,4.8,34.2,9.6 c9.5,4.2,19.2,8.5,29.6,9.3c23.5,1.8,55-0.6,73-13.1c1-0.7,2.4-0.5,3.1,0.6s0.5,2.4-0.6,3.2 C2251.8,1034.4,2225.5,1036.7,2208.1,1036.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1693.3,756.3c-0.7,0-1.4-0.3-1.9-1c-0.7-1-0.4-2.4,0.6-3.2c12.4-8.5,27.9-19,44.6-19 c9.6,0,18.3,3.4,26.7,6.7c6.4,2.5,13,5.1,19.7,6.1c9.8,1.4,17.9-2.2,26.6-6c3.9-1.7,7.9-3.4,12.1-4.8c16.8-5.3,31.5-6.5,43.5-3.4 c6.3,1.6,11.7,4.6,17,7.5c6,3.3,11.7,6.5,18.7,7.7c24.9,4.6,59.4,1.5,76.3-16.1c0.9-0.9,2.3-0.9,3.2-0.1c0.9,0.9,0.9,2.3,0.1,3.2 c-18.2,18.9-53.4,22.4-80.4,17.5c-7.7-1.4-14-4.9-20.1-8.2c-5.2-2.9-10.2-5.6-15.9-7.1c-11.2-2.9-25-1.8-41,3.3 c-4,1.3-7.9,3-11.7,4.6c-8.9,3.9-18,7.8-29.1,6.3c-7.3-1-14.1-3.7-20.8-6.3c-8.4-3.3-16.3-6.4-24.9-6.4c0,0-0.1,0-0.1,0 c-15.3,0-30.2,10.1-42.1,18.2C1694.2,756.2,1693.8,756.3,1693.3,756.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1906.7,780.6c-6.4,0-11.5-0.3-14.7-0.5c-11.2-0.9-21.3-5.3-31.1-9.7c-10.7-4.7-20.9-9.2-32.1-9.2 c-0.1,0-0.2,0-0.3,0c-10.9,0.1-20.5,3.7-30.6,7.5c-5,1.9-10.2,3.8-15.5,5.3c-20.6,5.7-41.1-1.7-56.7-8.8c-1.1-0.5-1.6-1.9-1.1-3 s1.9-1.6,3-1.1c14.9,6.8,34.4,13.9,53.6,8.6c5.2-1.4,10.2-3.3,15.1-5.2c10.1-3.8,20.5-7.7,32.2-7.8c12.3-0.1,23.4,4.8,34.2,9.6 c9.5,4.2,19.2,8.5,29.7,9.3c23.5,1.9,55-0.6,73-13.1c1-0.7,2.4-0.5,3.2,0.6c0.7,1,0.5,2.4-0.6,3.2 C1950.4,778.3,1924.1,780.6,1906.7,780.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084505419407910751820000016707894372486554249_",
    gradientUnits: "userSpaceOnUse",
    x1: 2138.8086,
    y1: 344.9533,
    x2: 2120.8096,
    y2: 269.9571,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2097,
    y: 1293.4,
    style: {
      fill: "url(#SVGID_00000084505419407910751820000016707894372486554249_)"
    },
    width: 40.8,
    height: 201.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031914592508291334420000015349651080409630856_",
    gradientUnits: "userSpaceOnUse",
    x1: 2161.0894,
    y1: 339.6054,
    x2: 2143.0903,
    y2: 264.6093,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031914592508291334420000015349651080409630856_)"
    },
    d: "M2160.4,1500.3c0,0.5-0.4,0.9-0.9,0.9 l-84,0.6c-1.9,0-3.5-1.5-3.5-3.4v-4.2c0-0.9,0.5-1.8,1.2-2.5s1.6-1,2.6-1l83.7,1.4c0.5,0,0.9,0.4,0.9,0.8L2160.4,1500.3 L2160.4,1500.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2351.5,1219.9l-320,4c-1.8,0-3.9,1.4-4.7,3l-87.3,172.1c-0.8,1.7-0.1,3,1.7,3.1l319.6,1.9 c1.9,0,4.1-1.4,5-3.1l87.7-177.9C2354.3,1221.2,2353.4,1219.9,2351.5,1219.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027595464766317744930000011342941993675710098_",
    gradientUnits: "userSpaceOnUse",
    x1: 1938.1503,
    y1: 199.0645,
    x2: 2172.1379,
    y2: 547.0467,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027595464766317744930000011342941993675710098_)"
    },
    d: "M2122.8,1234.7l-87.1,1 c-1.8,0-3.9,1.4-4.7,3l-20.1,39.6c-0.8,1.7-0.1,3,1.7,3l87-0.6c1.8,0,4-1.4,4.8-3.1l20.1-39.9 C2125.4,1236,2124.6,1234.7,2122.8,1234.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054231517002031425150000011627583475911290285_",
    gradientUnits: "userSpaceOnUse",
    x1: 2009.1736,
    y1: 151.3074,
    x2: 2243.1619,
    y2: 499.2902,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054231517002031425150000011627583475911290285_)"
    },
    d: "M2227.5,1233.6l-88.9,1 c-1.8,0-4,1.4-4.8,3.1l-20.1,40c-0.8,1.7-0.1,3,1.8,3l88.9-0.6c1.9,0,4-1.4,4.9-3.1l20.1-40.4 C2230.2,1234.9,2229.4,1233.5,2227.5,1233.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083782362547960169570000005254203736897791906_",
    gradientUnits: "userSpaceOnUse",
    x1: 2081.7346,
    y1: 102.5157,
    x2: 2315.7227,
    y2: 450.4981,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083782362547960169570000005254203736897791906_)"
    },
    d: "M2334.5,1232.4l-90.9,1 c-1.9,0-4,1.4-4.9,3.1l-20.1,40.4c-0.8,1.7,0,3.1,1.8,3.1l90.8-0.6c1.9,0,4.1-1.4,4.9-3.1l20.1-40.8 C2337.2,1233.7,2336.4,1232.3,2334.5,1232.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170961142776168733450000013277067715983016609_",
    gradientUnits: "userSpaceOnUse",
    x1: 1944.4287,
    y1: 194.8424,
    x2: 2178.4165,
    y2: 542.8247,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170961142776168733450000013277067715983016609_)"
    },
    d: "M2095.4,1289.2l-87,0.5 c-1.8,0-3.9,1.4-4.7,3l-20.1,39.8c-0.8,1.7-0.1,3,1.7,3l87-0.1c1.8,0,4-1.4,4.8-3.1l20.2-40.1 C2098,1290.6,2097.2,1289.2,2095.4,1289.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127040443255719806880000001699466119646566569_",
    gradientUnits: "userSpaceOnUse",
    x1: 2015.6926,
    y1: 146.9235,
    x2: 2249.6809,
    y2: 494.9063,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127040443255719806880000001699466119646566569_)"
    },
    d: "M2200.1,1288.6l-88.9,0.5 c-1.8,0-4,1.4-4.8,3.1l-20.2,40.2c-0.9,1.7-0.1,3.1,1.8,3.1l88.9-0.1c1.9,0,4-1.4,4.9-3.1l20.2-40.6 C2202.8,1290,2201.9,1288.6,2200.1,1288.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142146846671526924690000014167039373894263443_",
    gradientUnits: "userSpaceOnUse",
    x1: 2088.489,
    y1: 97.9737,
    x2: 2322.4771,
    y2: 445.9563,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142146846671526924690000014167039373894263443_)"
    },
    d: "M2307,1288l-90.8,0.5 c-1.9,0-4,1.4-4.9,3.1l-20.2,40.6c-0.9,1.7,0,3.1,1.8,3.1l90.8-0.1c1.9,0,4.1-1.4,5-3.1l20.2-41 C2309.7,1289.4,2308.9,1288,2307,1288z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051376622255583240650000001504491121531003292_",
    gradientUnits: "userSpaceOnUse",
    x1: 1950.7303,
    y1: 190.6049,
    x2: 2184.7183,
    y2: 538.5875,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051376622255583240650000001504491121531003292_)"
    },
    d: "M2067.9,1343.9h-87 c-1.8,0-3.9,1.3-4.8,3l-20.2,39.9c-0.8,1.7-0.1,3,1.7,3.1l87,0.4c1.8,0,4-1.3,4.8-3.1l20.3-40.3 C2070.5,1345.3,2069.7,1343.9,2067.9,1343.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016766876377399535510000004489780778692061335_",
    gradientUnits: "userSpaceOnUse",
    x1: 2022.2374,
    y1: 142.5227,
    x2: 2256.2251,
    y2: 490.505,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016766876377399535510000004489780778692061335_)"
    },
    d: "M2172.5,1343.9h-88.9 c-1.8,0-4,1.4-4.8,3.1l-20.3,40.4c-0.9,1.7-0.1,3.1,1.7,3.1l88.8,0.4c1.9,0,4-1.4,4.9-3.1l20.3-40.8 C2175.2,1345.3,2174.4,1343.9,2172.5,1343.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104684542072810496710000016465545503800516769_",
    gradientUnits: "userSpaceOnUse",
    x1: 2095.2859,
    y1: 93.4031,
    x2: 2329.2742,
    y2: 441.386,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104684542072810496710000016465545503800516769_)"
    },
    d: "M2279.4,1343.9h-90.8 c-1.9,0-4,1.4-4.9,3.1l-21.9,43.9l94.1,0.4c1.9,0,4.1-1.4,5-3.1l20.3-41.2C2282.1,1345.3,2281.3,1343.9,2279.4,1343.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005989039397220829690000017281530379455620514_",
    gradientUnits: "userSpaceOnUse",
    x1: 2195.6501,
    y1: 287.6147,
    x2: 2296.7295,
    y2: 287.6147,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005989039397220829690000017281530379455620514_)"
    },
    d: "M2258.7,1398.2 C2258.7,1398.2,2258.7,1398.2,2258.7,1398.2l-61.9-0.3c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0l61.9,0.3h0 c1.3,0,2.8-1.6,3.6-3.1l32.3-65.5c0.3-0.6,1-0.8,1.5-0.5s0.8,1,0.5,1.5l-32.3,65.5C2263.2,1395.9,2261,1398.2,2258.7,1398.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036227153893564443670000008980842386449617300_",
    gradientUnits: "userSpaceOnUse",
    x1: 2001.9686,
    y1: 393.9531,
    x2: 2105,
    y2: 393.9531,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036227153893564443670000008980842386449617300_)"
    },
    d: "M2003.1,1286.1c-0.2,0-0.3,0-0.5-0.1 c-0.6-0.3-0.8-1-0.5-1.5l27.6-54.5c1.1-2.1,3.9-3,6.1-3.1l68-0.8c0.6-0.1,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.2l-68.1,0.8 c-1.6,0-3.5,0.7-4.1,1.8l-27.6,54.5C2003.9,1285.8,2003.5,1286.1,2003.1,1286.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116235144527183443030000013267497336234907071_",
    gradientUnits: "userSpaceOnUse",
    x1: 1319.4481,
    y1: 2500.0061,
    x2: 1107.4478,
    y2: 1968.0054,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116235144527183443030000013267497336234907071_)"
    },
    d: "M787.2,527.5c-5,0-9.1-4.1-9.1-9.1 v-65.7c0-5,4.1-9.1,9.1-9.1c5,0,9.1,4.1,9.1,9.1v65.7C796.3,523.4,792.2,527.5,787.2,527.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110436646142629336070000010646136504496113052_",
    gradientUnits: "userSpaceOnUse",
    x1: 1318.8656,
    y1: 2500.2312,
    x2: 1106.8657,
    y2: 1968.2314,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110436646142629336070000010646136504496113052_)"
    },
    d: "M821.2,481c0,4.4-3.5,7.9-7.9,7.9 h-49.8c-4.4,0-7.9-3.5-7.9-7.9l0,0c0-4.4,3.5-7.9,7.9-7.9h49.8C817.7,473.1,821.2,476.7,821.2,481L821.2,481z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054954588844759660110000017434059552167053189_",
    gradientUnits: "userSpaceOnUse",
    x1: 1332.1141,
    y1: 2494.9568,
    x2: 1120.1135,
    y2: 1962.9557,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054954588844759660110000017434059552167053189_)"
    },
    d: "M821.2,519.6c0,4.4-3.5,7.9-7.9,7.9 h-49.8c-4.4,0-7.9-3.5-7.9-7.9l0,0c0-4.4,3.5-7.9,7.9-7.9h49.8C817.7,511.6,821.2,515.2,821.2,519.6L821.2,519.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152948420241506833330000015501675574966408638_",
    gradientUnits: "userSpaceOnUse",
    x1: 2052.7666,
    y1: 2207.7798,
    x2: 1840.7664,
    y2: 1675.7791,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152948420241506833330000015501675574966408638_)"
    },
    d: "M1637,527.5c-5,0-9.1-4.1-9.1-9.1 v-65.7c0-5,4.1-9.1,9.1-9.1s9.1,4.1,9.1,9.1v65.7C1646.1,523.4,1642,527.5,1637,527.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106868917036425999210000014326554632166612650_",
    gradientUnits: "userSpaceOnUse",
    x1: 2052.1858,
    y1: 2208.0078,
    x2: 1840.1859,
    y2: 1676.0084,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106868917036425999210000014326554632166612650_)"
    },
    d: "M1671,481c0,4.4-3.6,7.9-7.9,7.9 h-49.8c-4.4,0-7.9-3.5-7.9-7.9l0,0c0-4.4,3.6-7.9,7.9-7.9h49.8C1667.4,473.1,1671,476.7,1671,481L1671,481z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136369159369256287350000008935775250540760450_",
    gradientUnits: "userSpaceOnUse",
    x1: 2065.4321,
    y1: 2202.7297,
    x2: 1853.4319,
    y2: 1670.7289,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136369159369256287350000008935775250540760450_)"
    },
    d: "M1671,519.6c0,4.4-3.6,7.9-7.9,7.9 h-49.8c-4.4,0-7.9-3.5-7.9-7.9l0,0c0-4.4,3.6-7.9,7.9-7.9h49.8C1667.4,511.6,1671,515.2,1671,519.6L1671,519.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167368105024386707670000011339057889985592972_",
    gradientUnits: "userSpaceOnUse",
    x1: 2152.8689,
    y1: 2167.8904,
    x2: 1940.8687,
    y2: 1635.8901,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167368105024386707670000011339057889985592972_)"
    },
    d: "M1625.7,847c-5,0-9.1-4.1-9.1-9.1 v-65.7c0-5,4.1-9.1,9.1-9.1c5,0,9.1,4.1,9.1,9.1V838C1634.7,843,1630.7,847,1625.7,847z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047779336264989721540000006460803684008992915_",
    gradientUnits: "userSpaceOnUse",
    x1: 2152.2844,
    y1: 2168.1213,
    x2: 1940.2841,
    y2: 1636.1201,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047779336264989721540000006460803684008992915_)"
    },
    d: "M1659.7,800.6c0,4.4-3.6,7.9-7.9,7.9 h-49.8c-4.4,0-7.9-3.5-7.9-7.9l0,0c0-4.4,3.6-7.9,7.9-7.9h49.8C1656.1,792.6,1659.7,796.2,1659.7,800.6L1659.7,800.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036952330874461320560000014475761983080715148_",
    gradientUnits: "userSpaceOnUse",
    x1: 2165.5303,
    y1: 2162.8398,
    x2: 1953.5302,
    y2: 1630.8401,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036952330874461320560000014475761983080715148_)"
    },
    d: "M1659.7,839.1c0,4.4-3.6,7.9-7.9,7.9 h-49.8c-4.4,0-7.9-3.5-7.9-7.9l0,0c0-4.4,3.6-7.9,7.9-7.9h49.8C1656.1,831.2,1659.7,834.7,1659.7,839.1L1659.7,839.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036972857238396264990000014991457548052820884_",
    gradientUnits: "userSpaceOnUse",
    x1: 1429.3263,
    y1: 2456.218,
    x2: 1217.3262,
    y2: 1924.2179,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036972857238396264990000014991457548052820884_)"
    },
    d: "M787.2,847c-5,0-9.1-4.1-9.1-9.1v-65.7 c0-5,4.1-9.1,9.1-9.1c5,0,9.1,4.1,9.1,9.1V838C796.3,843,792.2,847,787.2,847z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085946789464678049330000008419065524457747841_",
    gradientUnits: "userSpaceOnUse",
    x1: 1428.7435,
    y1: 2456.4519,
    x2: 1216.7429,
    y2: 1924.4506,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085946789464678049330000008419065524457747841_)"
    },
    d: "M821.2,800.6c0,4.4-3.5,7.9-7.9,7.9 h-49.8c-4.4,0-7.9-3.5-7.9-7.9l0,0c0-4.4,3.5-7.9,7.9-7.9h49.8C817.7,792.6,821.2,796.2,821.2,800.6L821.2,800.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176761647288766534080000009361686207175392398_",
    gradientUnits: "userSpaceOnUse",
    x1: 1441.9884,
    y1: 2451.1697,
    x2: 1229.9885,
    y2: 1919.1699,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176761647288766534080000009361686207175392398_)"
    },
    d: "M821.2,839.1c0,4.4-3.5,7.9-7.9,7.9 h-49.8c-4.4,0-7.9-3.5-7.9-7.9l0,0c0-4.4,3.5-7.9,7.9-7.9h49.8C817.7,831.2,821.2,834.7,821.2,839.1L821.2,839.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128471680546767346440000010362291231406053812_",
    gradientUnits: "userSpaceOnUse",
    x1: 1895.286,
    y1: 2270.532,
    x2: 1683.2861,
    y2: 1738.5321,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128471680546767346440000010362291231406053812_)"
    },
    d: "M1496.4,1491.7c-4.4,0-8.3-3.2-8.9-7.7 L1295.6,214.6l-168.5,18.7L943.5,1483.9c-0.7,4.9-5.3,8.4-10.3,7.7c-5-0.7-8.4-5.3-7.7-10.3l184.5-1257.6c0.6-4.1,3.9-7.2,8-7.7 l184.1-20.4c4.8-0.5,9.2,2.8,10,7.6l193.1,1278c0.8,4.9-2.7,9.6-7.6,10.3C1497.3,1491.6,1496.8,1491.7,1496.4,1491.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145026489881182721020000018360738723899770772_",
    gradientUnits: "userSpaceOnUse",
    x1: 1679.2903,
    y1: 2356.6069,
    x2: 1467.29,
    y2: 1824.6063,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145026489881182721020000018360738723899770772_)"
    },
    d: "M1650.2,464H782.6 c-4.1,0-7.8-2.8-8.8-6.8s0.8-8.2,4.4-10.2l329.7-181.4c4.4-2.4,9.9-0.8,12.3,3.6s0.8,9.9-3.6,12.3L817.9,445.9h798.9 l-310.3-182.1c-4.3-2.5-5.8-8.1-3.2-12.4c2.5-4.3,8.1-5.8,12.4-3.2l339.1,199c3.5,2.1,5.2,6.2,4.2,10.2 C1657.9,461.3,1654.3,464,1650.2,464z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080888249991891138590000018433644942492180661_",
    gradientUnits: "userSpaceOnUse",
    x1: 1782.5261,
    y1: 2315.467,
    x2: 1570.5261,
    y2: 1783.4673,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080888249991891138590000018433644942492180661_)"
    },
    d: "M1636.6,781.3h-854 c-3.6,0-6.9-2.2-8.3-5.5c-1.4-3.3-0.7-7.2,1.8-9.8l303.1-316.6c3.5-3.6,9.2-3.7,12.8-0.3s3.7,9.2,0.3,12.8L803.8,763.2h811.9 L1334.6,462c-3.4-3.7-3.2-9.4,0.4-12.8c3.7-3.4,9.4-3.2,12.8,0.4L1643.2,766c2.5,2.6,3.1,6.5,1.7,9.8 C1643.5,779.2,1640.2,781.3,1636.6,781.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005965740909576566900000012182349005211279799_",
    gradientUnits: "userSpaceOnUse",
    x1: 1648.5696,
    y1: 2368.8477,
    x2: 1436.5697,
    y2: 1836.8481,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005965740909576566900000012182349005211279799_)"
    },
    d: "M1339.2,451.4c-2.3,0-4.6-0.9-6.4-2.6 l-220.1-217.3c-3.6-3.5-3.6-9.3-0.1-12.8c3.5-3.6,9.3-3.6,12.8-0.1l220.1,217.3c3.6,3.5,3.6,9.3,0.1,12.8 C1343.9,450.5,1341.5,451.4,1339.2,451.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165219546560486702400000012013711824276399764_",
    gradientUnits: "userSpaceOnUse",
    x1: 1615.803,
    y1: 2381.9053,
    x2: 1403.8035,
    y2: 1849.9061,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165219546560486702400000012013711824276399764_)"
    },
    d: "M1087.2,451.4c-2.2,0-4.4-0.8-6.1-2.4 c-3.7-3.4-4-9.1-0.6-12.8l216-237.7c3.4-3.7,9.1-4,12.8-0.6c3.7,3.4,4,9.1,0.6,12.8l-216,237.7 C1092.2,450.4,1089.7,451.4,1087.2,451.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023961910508119933030000013966616869821767554_",
    gradientUnits: "userSpaceOnUse",
    x1: 1750.672,
    y1: 2328.1604,
    x2: 1538.6719,
    y2: 1796.1606,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023961910508119933030000013966616869821767554_)"
    },
    d: "M978.1,1181.6c-2.4,0-4.7-0.9-6.5-2.7 c-3.5-3.6-3.4-9.3,0.2-12.8l402.3-391.3l-297.5-311.9c-3.5-3.6-3.3-9.4,0.3-12.8c3.6-3.5,9.4-3.3,12.8,0.3l303.7,318.4 c3.4,3.6,3.3,9.3-0.2,12.8L984.5,1179C982.7,1180.8,980.4,1181.6,978.1,1181.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042697371559314192890000005963565337692445327_",
    gradientUnits: "userSpaceOnUse",
    x1: 1069.3871,
    y1: 1631.3042,
    x2: 857.3872,
    y2: 1099.3044,
    gradientTransform: "matrix(-1 0 0 -1 2021.2183 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042697371559314192890000005963565337692445327_)"
    },
    d: "M1445.8,1179.3c-2.3,0-4.6-0.8-6.3-2.6 l-408.7-397.5c-3.6-3.5-3.7-9.2-0.2-12.8l303.7-318.4c3.5-3.6,9.2-3.8,12.8-0.3c3.6,3.5,3.8,9.2,0.3,12.8l-297.5,311.9 l402.3,391.2c3.6,3.5,3.7,9.2,0.2,12.8C1450.5,1178.4,1448.1,1179.3,1445.8,1179.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026859009075551985210000000150669709847985808_",
    gradientUnits: "userSpaceOnUse",
    x1: 1928.4731,
    y1: 2257.3088,
    x2: 1716.4733,
    y2: 1725.3092,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026859009075551985210000000150669709847985808_)"
    },
    d: "M1451.2,1193.7H977.6 c-5,0-9.1-4.1-9.1-9.1s4.1-9.1,9.1-9.1h473.6c5,0,9.1,4.1,9.1,9.1S1456.2,1193.7,1451.2,1193.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035529485768875048030000017169215699176647864_",
    gradientUnits: "userSpaceOnUse",
    x1: 1821.9865,
    y1: 2299.7429,
    x2: 1609.9862,
    y2: 1767.7423,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035529485768875048030000017169215699176647864_)"
    },
    d: "M936.5,1478.7c-1.8,0-3.6-0.5-5.1-1.6 c-4.1-2.8-5.2-8.5-2.3-12.6l194.8-283.3c2.8-4.1,8.5-5.2,12.6-2.3c4.1,2.8,5.2,8.5,2.3,12.6l-194.8,283.3 C942.2,1477.3,939.4,1478.7,936.5,1478.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018936779788455701620000011358345886503613884_",
    gradientUnits: "userSpaceOnUse",
    x1: 894.8046,
    y1: 1700.8748,
    x2: 682.8049,
    y2: 1168.8759,
    gradientTransform: "matrix(-1 0 0 -1 1744.0449 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018936779788455701620000011358345886503613884_)"
    },
    d: "M1496.1,1478.7c-2.9,0-5.7-1.4-7.5-3.9 l-194.8-283.3c-2.8-4.1-1.8-9.8,2.3-12.6c4.1-2.8,9.8-1.8,12.6,2.3l194.8,283.3c2.8,4.1,1.8,9.8-2.3,12.6 C1499.7,1478.2,1497.9,1478.7,1496.1,1478.7z"
  })), /*#__PURE__*/React.createElement("g", null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M653.4,830.7c0,0,33.8-57.1-27.5-41.1s-95,3.7-136.5-26.3c-41.6-30-52.1-34.6-86-27.9s-85.1-38.3-60.9-56.9 c24.2-18.5,72.5-20.8,99.6-0.8c27.1,20,60,4.1,112.2,6.7c52.2,2.6,81.2,12.3,90.9,37.5c9.7,25.1,19.3-8.8,39.7,37.7 c0,0,42.1,16.4,29,47.9c-13,31.4-16,49.7-16,49.7H650L653.4,830.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.9,830.7c0,0,33.8-57.1-27.5-41.1s-95,3.7-136.5-26.3c-41.6-30-52.1-34.6-86-27.9S155.9,697,180,678.5 c24.2-18.5,72.5-20.8,99.6-0.8c27.1,20,60,4.1,112.2,6.7c52.2,2.6,81.2,12.3,90.9,37.5s19.3-8.8,39.6,37.7c0,0,42.1,16.4,29,47.9 c-13,31.4-16,49.7-16,49.7h-47.9L490.9,830.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "710.4,1164.3 637.7,1164.3 637.7,1114.2 641.6,961.7 641.2,950.1 641.3,936.6 641.5,925  644,853.5 644,851.5 710.2,851.5 710.2,961.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077283033430190963620000016004367069986140297_",
    gradientUnits: "userSpaceOnUse",
    x1: 633.13,
    y1: 805.25,
    x2: 719.24,
    y2: 805.25,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077283033430190963620000016004367069986140297_)"
    },
    d: "M719.2,841.8c0-2.1-1.7-3.9-3.9-3.9 H637c-2.1,0-3.9,1.7-3.9,3.9v5.9c0,2.1,1.7,3.9,3.9,3.9h78.4c2.1,0,3.9-1.7,3.9-3.9V841.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000217971235115999980000010976085190175468217_",
    gradientUnits: "userSpaceOnUse",
    x1: 694.0475,
    y1: 877.2836,
    x2: 666.0477,
    y2: 635.2839,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000000217971235115999980000010976085190175468217_)"
    },
    points: "710.2,926.3 710.2,935.4  640.9,935.4 641.3,926.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046313813702499417970000016494227556025600695_",
    gradientUnits: "userSpaceOnUse",
    x1: 696.1956,
    y1: 877.0352,
    x2: 668.1956,
    y2: 635.0345,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000046313813702499417970000016494227556025600695_)"
    },
    points: "710.2,946.7 710.2,960.3  640,960.3 640.4,946.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "543.4,1164.3 467.7,1164.3 467.7,1114.2 473.1,961.7 473.4,950.1 473.9,936.6 474.3,925  476.9,853.5 476.9,851.5 540.2,851.5 540.2,961.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178199944485054445720000013334395163202352317_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.44,
    y1: 805.25,
    x2: 551.55,
    y2: 805.25,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178199944485054445720000013334395163202352317_)"
    },
    d: "M551.5,841.8c0-2.1-1.7-3.9-3.9-3.9 h-78.4c-2.1,0-3.9,1.7-3.9,3.9v5.9c0,2.1,1.7,3.9,3.9,3.9h78.4c2.1,0,3.9-1.7,3.9-3.9V841.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179626666329811319910000017748962017568088255_",
    gradientUnits: "userSpaceOnUse",
    x1: 527.7685,
    y1: 896.5219,
    x2: 499.7686,
    y2: 654.5223,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000179626666329811319910000017748962017568088255_)"
    },
    points: "540.2,926.3 540.2,935.4  473.9,935.4 474.3,926.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097466198397165720000000004179632895121226114_",
    gradientUnits: "userSpaceOnUse",
    x1: 529.9166,
    y1: 896.274,
    x2: 501.9168,
    y2: 654.2751,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000097466198397165720000000004179632895121226114_)"
    },
    points: "540.2,946.7 540.2,960.3  473,960.3 473.4,946.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169540400383266129940000004166969755167681447_",
    gradientUnits: "userSpaceOnUse",
    x1: 454.8731,
    y1: 180.8985,
    x2: 582.874,
    y2: 768.9,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169540400383266129940000004166969755167681447_)"
    },
    d: "M732.8,1139.3H243.3 c-7.1,0-12.6,5.7-12.5,12.9l8.6,336.1c0.2,6.9,5.9,12.4,12.8,12.4l479.7-2.2c6.8,0,12.4-5.6,12.4-12.4l1.1-334 C745.4,1145,739.8,1139.3,732.8,1139.3z"
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M290.2,1200.5h-15.2c-0.7,0-1.4,0.7-1.9,1.2c-0.5,0.5-0.8,1.4-0.7,2.1l1.9,46.3c0.1,1.4,1.2,2.5,2.6,2.5 h14.9c0.7,0,1.4-0.2,1.9-0.7s0.8-1.2,0.7-1.9l-1.5-46.7C292.7,1202,291.6,1200.5,290.2,1200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M356.2,1200.5h-15.3c-0.7,0-1.4,0.7-1.9,1.2s-0.8,1.4-0.8,2.1l0.6,46.3c0,1.4,1.2,2.6,2.6,2.6h14.9 c0.7,0,1.4-0.2,1.9-0.7c0.5-0.5,0.8-1.1,0.8-1.8l-0.3-46.7C358.8,1202.1,357.6,1200.5,356.2,1200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M414.2,1200.5H399c-1.4,0-2.6,1.6-2.6,3l-0.4,46.5c0,0.7,0.3,1.4,0.8,1.9c0.5,0.5,1.2,0.8,1.9,0.8h14.9 c1.4,0,2.6-1.1,2.6-2.5l0.8-46.2c0-0.7-0.3-1.7-0.8-2.2C415.6,1201.2,414.9,1200.5,414.2,1200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M474.2,1201.7c-0.5-0.5-1.2-1.2-1.9-1.2H457c-1.4,0-2.6,1.5-2.6,2.9l-1.5,46.5c0,0.7,0.2,1.4,0.7,1.9 c0.5,0.5,1.2,0.8,1.9,0.8h14.9c1.4,0,2.6-1,2.6-2.4l1.9-46.4C474.9,1203.1,474.6,1202.2,474.2,1201.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M528.2,1200.5h-15.2c-0.7,0-1.4,0.7-1.9,1.2c-0.5,0.5-0.8,1.4-0.7,2.1l1.9,46.3c0.1,1.4,1.2,2.5,2.6,2.5 h14.9c0.7,0,1.4-0.2,1.9-0.7s0.8-1.2,0.7-1.9l-1.5-46.7C530.7,1202,529.6,1200.5,528.2,1200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M594.2,1200.5h-15.3c-0.7,0-1.4,0.7-1.9,1.2s-0.8,1.4-0.8,2.1l0.7,46.3c0,1.4,1.2,2.6,2.6,2.6h14.9 c0.7,0,1.4-0.2,1.8-0.7c0.5-0.5,0.8-1.1,0.8-1.8l-0.3-46.7C596.8,1202.1,595.6,1200.5,594.2,1200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M652.2,1200.5H637c-1.4,0-2.6,1.6-2.6,3l-0.4,46.5c0,0.7,0.3,1.4,0.8,1.9s1.2,0.8,1.9,0.8h14.9 c1.4,0,2.6-1.1,2.6-2.5l0.8-46.2c0-0.7-0.3-1.7-0.8-2.2S652.9,1200.5,652.2,1200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M712.2,1201.7c-0.5-0.5-1.2-1.2-1.9-1.2H695c-1.4,0-2.6,1.5-2.6,2.9l-1.5,46.5c0,0.7,0.2,1.4,0.7,1.9 c0.5,0.5,1.2,0.8,1.9,0.8h14.9c1.4,0,2.6-1,2.6-2.4l1.8-46.4C712.9,1203.1,712.7,1202.2,712.2,1201.7z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M290.2,1300.2h-15.2c-0.7,0-1.4,1.2-1.9,1.7c-0.5,0.5-0.8,1.7-0.7,2.4l1.9,45.9c0.1,1.4,1.2,2.1,2.6,2.1 h14.9c0.7,0,1.4,0.3,1.9-0.2s0.8-0.9,0.7-1.6l-1.5-47C292.7,1302.1,291.6,1300.2,290.2,1300.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M356.2,1300.2h-15.3c-0.7,0-1.4,1.2-1.9,1.7s-0.8,1.6-0.8,2.3l0.6,45.9c0,1.4,1.2,2.2,2.6,2.2h14.9 c0.7,0,1.4,0.3,1.9-0.2c0.5-0.5,0.8-0.9,0.8-1.6l-0.3-47C358.8,1302.1,357.6,1300.2,356.2,1300.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M414.2,1300.2H399c-1.4,0-2.6,2-2.6,3.5l-0.4,46.7c0,0.7,0.3,1,0.8,1.5c0.5,0.5,1.2,0.4,1.9,0.4h14.9 c1.4,0,2.6-0.6,2.6-2l0.8-46c0-0.7-0.3-2.1-0.8-2.6C415.6,1301.2,414.9,1300.2,414.2,1300.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M474.2,1301.9c-0.5-0.5-1.2-1.7-1.9-1.7H457c-1.4,0-2.6,2-2.6,3.4l-1.5,46.7c0,0.7,0.2,1,0.7,1.5 c0.5,0.5,1.2,0.4,1.9,0.4h14.9c1.4,0,2.6-0.5,2.6-1.9l1.9-46.4C474.9,1303.3,474.6,1302.4,474.2,1301.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M528.2,1300.2h-15.2c-0.7,0-1.4,1.2-1.9,1.7c-0.5,0.5-0.8,1.7-0.7,2.4l1.9,45.9c0.1,1.4,1.2,2.1,2.6,2.1 h14.9c0.7,0,1.4,0.3,1.9-0.2s0.8-0.9,0.7-1.6l-1.5-47C530.7,1302.1,529.6,1300.2,528.2,1300.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M594.2,1300.2h-15.3c-0.7,0-1.4,1.2-1.9,1.7s-0.8,1.6-0.8,2.3l0.7,45.9c0,1.4,1.2,2.2,2.6,2.2h14.9 c0.7,0,1.4,0.3,1.8-0.2c0.5-0.5,0.8-0.9,0.8-1.6l-0.3-47C596.8,1302.1,595.6,1300.2,594.2,1300.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M652.2,1300.2H637c-1.4,0-2.6,2-2.6,3.5l-0.4,46.7c0,0.7,0.3,1,0.8,1.5s1.2,0.4,1.9,0.4h14.9 c1.4,0,2.6-0.6,2.6-2l0.8-46c0-0.7-0.3-2.1-0.8-2.6C653.6,1301.2,652.9,1300.2,652.2,1300.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M712.2,1301.9c-0.5-0.5-1.2-1.7-1.9-1.7H695c-1.4,0-2.6,2-2.6,3.4l-1.5,46.7c0,0.7,0.2,1,0.7,1.5 c0.5,0.5,1.2,0.4,1.9,0.4h14.9c1.4,0,2.6-0.5,2.6-1.9l1.8-46.4C712.9,1303.3,712.7,1302.4,712.2,1301.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101076205813534941380000002349796338462238377_",
    gradientUnits: "userSpaceOnUse",
    x1: 1775.9144,
    y1: 398.7533,
    x2: 1729.4166,
    y2: 305.7581,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1693.6,
    y: 1248.1,
    style: {
      fill: "url(#SVGID_00000101076205813534941380000002349796338462238377_)"
    },
    width: 45.3,
    height: 244.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121973562666143625830000016002285844095554466_",
    gradientUnits: "userSpaceOnUse",
    x1: 1824.923,
    y1: 374.2495,
    x2: 1778.4252,
    y2: 281.2538,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121973562666143625830000016002285844095554466_)"
    },
    d: "M1768.4,1499c0,0.6-0.3,1-0.9,1 l-101,0.7c-2.3,0-4.6-1.8-4.6-4v-5c0-1.1,1.1-2.2,1.9-3c0.8-0.8,2.2-1.2,3.3-1.2l100.3,1.7c0.6,0,1.1,0.4,1.1,1L1768.4,1499 L1768.4,1499z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1997.7,1163l-383.4,4.8c-2.1,0-4.7,1.7-5.7,3.6l-104.6,206.2c-1,2-0.1,3.6,2,3.7l382.9,2.3 c2.3,0,4.9-1.7,6-3.7l105.1-213.1C2001,1164.6,2000,1162.9,1997.7,1163z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177449642209165092070000012708711451689804695_",
    gradientUnits: "userSpaceOnUse",
    x1: 1632.9214,
    y1: 404.3039,
    x2: 1866.9095,
    y2: 752.2866,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177449642209165092070000012708711451689804695_)"
    },
    d: "M1723.7,1180.7l-104.3,1.2 c-2.1,0-4.7,1.7-5.7,3.6l-24,47.4c-1,2-0.1,3.6,2,3.6l104.3-0.7c2.2,0,4.8-1.7,5.8-3.7l24.1-47.9 C1726.8,1182.3,1725.8,1180.7,1723.7,1180.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016758837593699500080000003959210722166967487_",
    gradientUnits: "userSpaceOnUse",
    x1: 1718.019,
    y1: 347.0831,
    x2: 1952.0067,
    y2: 695.0651,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016758837593699500080000003959210722166967487_)"
    },
    d: "M1849.1,1179.3l-106.6,1.2 c-2.2,0-4.8,1.7-5.8,3.7l-24.1,47.9c-1,2-0.1,3.6,2.1,3.6l106.5-0.7c2.2,0,4.8-1.7,5.8-3.7l24.1-48.4 C1852.3,1180.9,1851.3,1179.3,1849.1,1179.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158001157942820032750000004500127435896243101_",
    gradientUnits: "userSpaceOnUse",
    x1: 1804.9457,
    y1: 288.6325,
    x2: 2038.9338,
    y2: 636.6154,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158001157942820032750000004500127435896243101_)"
    },
    d: "M1977.3,1177.9l-108.9,1.2 c-2.2,0-4.8,1.7-5.8,3.7l-24.1,48.4c-1,2,0,3.7,2.2,3.7l108.8-0.7c2.3,0,4.9-1.7,5.9-3.7l24.1-48.9 C1980.6,1179.5,1979.5,1177.9,1977.3,1177.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159441940186449282400000016168387021964445107_",
    gradientUnits: "userSpaceOnUse",
    x1: 1640.4413,
    y1: 399.2475,
    x2: 1874.4296,
    y2: 747.2303,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159441940186449282400000016168387021964445107_)"
    },
    d: "M1690.8,1246l-104.3,0.6 c-2.1,0-4.7,1.6-5.7,3.6l-24.1,47.6c-1,2-0.1,3.6,2,3.6l104.2-0.1c2.2,0,4.8-1.6,5.8-3.7l24.2-48.1 C1694,1247.6,1693,1246,1690.8,1246z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083807232207260479750000007340553057653121931_",
    gradientUnits: "userSpaceOnUse",
    x1: 1725.8187,
    y1: 341.8385,
    x2: 1959.8065,
    y2: 689.8208,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083807232207260479750000007340553057653121931_)"
    },
    d: "M1816.2,1245.3l-106.5,0.6 c-2.2,0-4.8,1.7-5.8,3.7l-24.2,48.1c-1,2-0.1,3.7,2.1,3.7l106.5-0.1c2.2,0,4.8-1.7,5.8-3.7l24.2-48.6 C1819.4,1246.9,1818.5,1245.3,1816.2,1245.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160159468737860493080000010835523120246297274_",
    gradientUnits: "userSpaceOnUse",
    x1: 1813.0428,
    y1: 283.1877,
    x2: 2047.0306,
    y2: 631.17,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160159468737860493080000010835523120246297274_)"
    },
    d: "M1944.3,1244.6l-108.8,0.6 c-2.2,0-4.8,1.7-5.8,3.7l-24.2,48.7c-1,2,0,3.7,2.2,3.7l108.8-0.1c2.3,0,4.9-1.7,5.9-3.7l24.2-49.1 C1947.6,1246.2,1946.6,1244.6,1944.3,1244.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182527203024195987380000015706809196459099304_",
    gradientUnits: "userSpaceOnUse",
    x1: 1647.9977,
    y1: 394.1657,
    x2: 1881.9855,
    y2: 742.1479,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182527203024195987380000015706809196459099304_)"
    },
    d: "M1657.9,1311.6h-104.2 c-2.1,0-4.7,1.6-5.7,3.6l-24.2,47.8c-1,2-0.1,3.6,2,3.7l104.2,0.5c2.2,0,4.8-1.6,5.8-3.7l24.3-48.3 C1661,1313.2,1660.1,1311.6,1657.9,1311.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142895871686452231280000008559111242910470810_",
    gradientUnits: "userSpaceOnUse",
    x1: 1733.6649,
    y1: 336.5626,
    x2: 1967.6528,
    y2: 684.5451,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142895871686452231280000008559111242910470810_)"
    },
    d: "M1783.2,1311.6h-106.5 c-2.2,0-4.8,1.6-5.8,3.7l-24.3,48.4c-1,2-0.1,3.7,2.1,3.7l106.4,0.5c2.2,0,4.8-1.6,5.9-3.7l24.3-48.8 C1786.4,1313.2,1785.4,1311.6,1783.2,1311.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006670773334983839880000012272418048512524181_",
    gradientUnits: "userSpaceOnUse",
    x1: 1821.1692,
    y1: 277.7236,
    x2: 2055.1575,
    y2: 625.7066,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006670773334983839880000012272418048512524181_)"
    },
    d: "M1911.3,1311.6h-108.8 c-2.2,0-4.8,1.7-5.9,3.7l-26.2,52.6l112.8,0.5c2.3,0,4.9-1.7,5.9-3.7l24.4-49.4C1914.5,1313.2,1913.5,1311.6,1911.3,1311.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104702979922007661560000004881650626450709133_",
    gradientUnits: "userSpaceOnUse",
    x1: 1811.1599,
    y1: 316.3296,
    x2: 1931.8093,
    y2: 316.3296,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104702979922007661560000004881650626450709133_)"
    },
    d: "M1886.4,1376.3 C1886.4,1376.3,1886.4,1376.3,1886.4,1376.3l-74.2-0.4c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1l0,0l74.1,0.4h0 c1.6,0,3.5-2,4.5-3.8l38.8-78.5c0.3-0.6,1-0.8,1.5-0.5s0.8,1,0.5,1.5l-38.8,78.5C1891.7,1373.7,1889.2,1376.3,1886.4,1376.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025404950240303826660000000836527281078936464_",
    gradientUnits: "userSpaceOnUse",
    x1: 1579.1086,
    y1: 443.725,
    x2: 1702.1001,
    y2: 443.725,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025404950240303826660000000836527281078936464_)"
    },
    d: "M1580.2,1242c-0.2,0-0.3,0-0.5-0.1 c-0.6-0.3-0.8-1-0.5-1.5l33.1-65.3c1.2-2.4,4.5-3.5,7.1-3.5l81.5-1c0.6,0,1.1,0.5,1.2,1.1s-0.5,1.1-1.1,1.2l-81.5,1 c-1.9,0-4.3,0.8-5.1,2.3l-33.1,65.3C1581.1,1241.8,1580.7,1242,1580.2,1242z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M220.7,992.3c-1.2-0.9-1.7-2.4-1.4-3.8l3.2-13.2c-4.4-4.7-8.1-10-11-15.8l-13.5-1.6 c-1.6-0.2-2.8-1.3-3.1-2.8l-3.9-17.5c-0.3-1.5,0.3-3.1,1.7-3.9l11.6-7.1c0.2-6.5,1.3-12.8,3.4-18.9l-8.5-10.7 c-1-1.2-1.1-2.9-0.2-4.2l9.6-15.1c0.8-1.3,2.4-2,3.9-1.6l13.2,3.2c4.7-4.4,10-8.1,15.8-11l1.6-13.5c0.2-1.5,1.3-2.8,2.8-3.1 l17.5-3.9c1.5-0.3,3.1,0.3,3.9,1.7l7.1,11.6c6.5,0.2,12.8,1.3,18.9,3.3l10.7-8.5c1.2-1,2.9-1,4.2-0.2l15.1,9.7 c1.3,0.8,2,2.4,1.6,3.9l-3.2,13.2c4.4,4.7,8.1,10,11,15.8l13.5,1.6c1.5,0.2,2.8,1.3,3.1,2.8l3.9,17.5c0.3,1.5-0.3,3.1-1.7,3.9 l-11.6,7.1c-0.2,6.5-1.3,12.8-3.4,18.9l8.5,10.7c1,1.2,1,2.9,0.2,4.2l-9.6,15.1c-0.8,1.3-2.4,2-3.9,1.6l-13.2-3.2 c-4.7,4.4-10,8.1-15.8,11l-1.6,13.5c-0.2,1.5-1.3,2.8-2.8,3.1l-17.5,3.9c-1.5,0.3-3.1-0.3-3.9-1.7l-7.1-11.6 c-6.5-0.2-12.8-1.3-18.9-3.3l-10.7,8.5c-1.2,1-2.9,1-4.2,0.2l-15.1-9.7C220.8,992.4,220.7,992.3,220.7,992.3z M214.7,955 l0.6,1.2c3,6.2,6.9,11.8,11.6,16.7l0.9,1l-3.6,15l13.7,8.7l12.1-9.6l1.3,0.4c6.4,2.3,13.1,3.5,20,3.5l1.3,0l8,13.2l15.8-3.5 l1.8-15.3l1.2-0.6c6.2-3,11.8-6.9,16.6-11.6l1-0.9l15,3.6l8.7-13.7l-9.6-12.1l0.4-1.3c2.3-6.4,3.5-13.2,3.5-20l0-1.3l13.2-8 l-3.5-15.8l-15.3-1.8l-0.6-1.2c-3-6.2-6.9-11.8-11.6-16.7l-0.9-1l3.6-15l-13.7-8.7l-12.1,9.6l-1.3-0.4c-6.4-2.3-13.1-3.5-20-3.5 l-1.3,0l-8-13.2l-15.8,3.5l-1.8,15.3l-1.2,0.6c-6.2,3-11.8,6.9-16.6,11.6l-1,0.9l-15-3.6l-8.7,13.7l9.6,12.1l-0.4,1.3 c-2.3,6.4-3.4,13.2-3.5,20l0,1.3l-13.2,8l3.5,15.8L214.7,955z M245.4,965.5c-1.8-1.3-3.5-2.8-5.1-4.3c-0.9-0.9-1-2.5,0-3.4 s2.5-1,3.4,0c2.1,2,4.3,3.9,6.8,5.4c19,12.1,44.3,6.5,56.4-12.4c12.1-19,6.5-44.3-12.4-56.4c-19-12.1-44.3-6.5-56.4,12.4 c-4,6.2-6.2,13.4-6.4,20.8c0,1.3-1.1,2.4-2.5,2.3c-1.3,0-2.4-1.2-2.4-2.5c0.2-8.2,2.7-16.3,7.2-23.2c6.6-10.3,16.7-17.4,28.7-20 s24.1-0.5,34.4,6.1c21.2,13.5,27.5,41.8,13.9,63.1s-41.8,27.5-63.1,13.9C247,966.7,246.2,966.2,245.4,965.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M261.2,943.7c-2.3-1.7-4.2-3.9-5.5-6.5c-2.2-4.4-2.6-9.3-1-14c3.2-9.6,13.6-14.8,23.2-11.6 c4.6,1.5,8.4,4.8,10.6,9.2c2.2,4.4,2.5,9.3,1,14c-3.2,9.6-13.6,14.8-23.2,11.6l0,0C264.4,945.7,262.7,944.8,261.2,943.7z  M280.1,918c-1.1-0.8-2.4-1.5-3.8-1.9c-7.1-2.3-14.7,1.5-17.1,8.5c-1.1,3.4-0.9,7.1,0.7,10.3c1.6,3.2,4.4,5.6,7.8,6.8l0,0 c7.1,2.3,14.7-1.5,17.1-8.5c1.1-3.4,0.9-7.1-0.7-10.3C283.2,920.9,281.8,919.3,280.1,918z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M387.4,920.5c-0.6-0.4-0.9-1.1-1-1.8l-0.4-6.2c-2.5-1.5-4.8-3.3-6.9-5.4l-6.1,1.1c-1,0.2-2-0.3-2.5-1.2 l-4.2-7.5c-0.5-0.9-0.4-2,0.3-2.8l4.1-4.6c-0.7-2.8-1.1-5.8-1-8.7l-5.1-3.5c-0.8-0.6-1.2-1.6-1-2.6l2.3-8.3 c0.3-1,1.1-1.7,2.2-1.8l6.2-0.4c1.5-2.5,3.3-4.8,5.4-6.9l-1.1-6.1c-0.2-1,0.3-2,1.2-2.5l7.5-4.2c0.9-0.5,2-0.4,2.8,0.3l4.6,4.1 c2.8-0.7,5.8-1.1,8.7-1l3.5-5.1c0.6-0.8,1.6-1.2,2.6-1l8.3,2.3c1,0.3,1.7,1.2,1.8,2.2l0.4,6.2c2.5,1.5,4.8,3.3,6.9,5.4l6.1-1.1 c1-0.2,2,0.3,2.5,1.2l4.2,7.5c0.5,0.9,0.4,2-0.3,2.8l-4.1,4.6c0.7,2.8,1.1,5.7,1,8.7l5.1,3.5c0.9,0.6,1.2,1.6,1,2.6l-2.3,8.3 c-0.3,1-1.1,1.7-2.2,1.8l-6.2,0.4c-1.5,2.5-3.3,4.8-5.4,6.9l1.1,6.1c0.2,1-0.3,2-1.2,2.5l-7.5,4.2c-0.9,0.5-2,0.4-2.8-0.3 l-4.6-4.1c-2.8,0.7-5.8,1.1-8.7,1l-3.5,5.1c-0.6,0.8-1.6,1.2-2.6,1l-8.3-2.3C387.9,920.8,387.6,920.6,387.4,920.5z M389.5,910.3 l0.4,7.3l6.6,1.9l4.2-6l1,0c3.2,0.1,6.4-0.2,9.5-1.1l1-0.3l5.5,4.9l6-3.4l-1.3-7.2l0.7-0.7c2.4-2.2,4.4-4.7,5.9-7.5l0.5-0.9 l7.3-0.4l1.9-6.6l-6-4.2l0-1c0.1-3.2-0.2-6.4-1.1-9.5l-0.3-1l4.9-5.5l-3.4-6l-7.2,1.3l-0.7-0.7c-2.2-2.4-4.7-4.4-7.5-5.9 l-0.9-0.5L416,850l-6.6-1.9l-4.2,6l-1,0c-3.2-0.1-6.4,0.2-9.5,1.1l-1,0.3l-5.5-4.9l-6,3.4l1.3,7.2l-0.7,0.7 c-2.4,2.2-4.4,4.7-5.9,7.5l-0.5,0.9l-7.3,0.4l-1.9,6.6l6,4.2l0,1c-0.1,3.2,0.2,6.4,1.1,9.5l0.3,1l-4.9,5.5l3.4,6l7.2-1.3 l0.7,0.7c2.2,2.4,4.7,4.4,7.5,5.9L389.5,910.3z M373.7,905.2L373.7,905.2L373.7,905.2z M396.1,920.2 C396.1,920.2,396.1,920.2,396.1,920.2L396.1,920.2z M366.7,876.9L366.7,876.9L366.7,876.9z M369.5,869.9L369.5,869.9 C369.5,869.9,369.5,869.9,369.5,869.9z M436.5,897.7L436.5,897.7L436.5,897.7z M437.6,896.8L437.6,896.8L437.6,896.8z  M432.3,862.4L432.3,862.4L432.3,862.4z M392.4,903.6c-0.7-0.5-1-1.5-0.5-2.3c0.5-0.9,1.6-1.2,2.5-0.8c1.2,0.6,2.5,1.1,3.8,1.5 c10.1,2.8,20.6-3.1,23.4-13.2c2.8-10.1-3.1-20.6-13.1-23.4c-10.1-2.8-20.6,3.1-23.4,13.2c-0.9,3.3-1,6.8,0,10.1 c0.3,1-0.3,2-1.3,2.2c-1,0.3-2-0.3-2.2-1.3c-1.1-3.9-1.1-8.1,0-12c3.4-12,15.9-19,27.9-15.7c5.8,1.6,10.6,5.4,13.6,10.7 s3.7,11.4,2.1,17.2s-5.4,10.7-10.7,13.6c-5.3,3-11.4,3.7-17.2,2.1c-1.6-0.4-3.1-1-4.5-1.8C392.5,903.7,392.4,903.6,392.4,903.6z "
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190.9,998.7l-3.8,5.5c-0.7,1-2,1.2-3,0.5c-1-0.7-1.2-2-0.5-3l0,0l3.8-5.4c0.7-1,2-1.2,3-0.5 C191.3,996.4,191.6,997.7,190.9,998.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M178.7,1017l-3.4,5.7c-0.6,1-2,1.4-3,0.8s-1.4-2-0.8-3l0,0l3.4-5.7c0.6-1,2-1.4,3-0.8 C179,1014.7,179.3,1016,178.7,1017z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M168,1036.3l-2.9,6c-0.5,1.1-1.9,1.6-3,1s-1.6-1.9-1-3l0,0l2.9-6c0.5-1.1,1.9-1.5,2.9-1 C168.1,1033.9,168.6,1035.2,168,1036.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M158.9,1056.3l-2.5,6.2c-0.5,1.1-1.8,1.7-2.9,1.2c-1.1-0.5-1.7-1.8-1.2-2.9l0,0l2.5-6.2 c0.5-1.1,1.8-1.7,2.9-1.2C158.8,1053.8,159.3,1055.1,158.9,1056.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M151.3,1076.9l-2,6.4c-0.4,1.2-1.6,1.8-2.8,1.5s-1.9-1.6-1.5-2.8l0,0l2-6.3c0.4-1.2,1.6-1.8,2.8-1.5 C151,1074.5,151.7,1075.8,151.3,1076.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M145.4,1098.1l-1.5,6.5c-0.3,1.2-1.5,2-2.7,1.7s-2-1.5-1.7-2.7l0,0l1.5-6.5c0.3-1.2,1.5-2,2.7-1.7 C144.9,1095.7,145.6,1096.9,145.4,1098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M141.1,1119.7l-0.9,6.6c-0.2,1.2-1.3,2.1-2.6,1.9c-1.2-0.2-2.1-1.3-1.9-2.6l0,0l0.9-6.6 c0.2-1.2,1.3-2.1,2.6-1.9S141.3,1118.5,141.1,1119.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M138.7,1141.6l-0.4,6.6c-0.1,1.3-1.2,2.2-2.4,2.2c-1.3-0.1-2.2-1.2-2.2-2.4l0,0l0.4-6.6 c0.1-1.3,1.2-2.2,2.4-2.2C137.8,1139.2,138.8,1140.3,138.7,1141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M138.2,1163.5l0.2,6.6v0c0,1.3-1,2.4-2.3,2.4s-2.4-1-2.4-2.3l0,0l-0.2-6.7c0-1.3,1-2.3,2.3-2.4 C137.1,1161.2,138.1,1162.2,138.2,1163.5L138.2,1163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M139.5,1185.5l0.8,6.6c0.1,1.3-0.8,2.4-2.1,2.6c-1.3,0.2-2.4-0.8-2.6-2.1l0,0l-0.7-6.6 c-0.1-1.3,0.8-2.4,2.1-2.6C138.2,1183.3,139.4,1184.2,139.5,1185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M142.6,1207.2l1.3,6.5c0.2,1.3-0.6,2.5-1.9,2.8c-1.3,0.2-2.5-0.6-2.8-1.9l0,0l-1.3-6.5 c-0.2-1.3,0.6-2.5,1.9-2.8C141.1,1205.1,142.3,1206,142.6,1207.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M147.4,1228.7l1.8,6.4c0.4,1.3-0.4,2.6-1.7,2.9s-2.6-0.4-2.9-1.7l0,0l-1.8-6.4c-0.4-1.3,0.4-2.6,1.7-2.9 C145.7,1226.7,147,1227.4,147.4,1228.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M153.8,1249.8l2.2,6.3c0.4,1.2-0.2,2.6-1.5,3.1c-1.2,0.4-2.6-0.2-3.1-1.5l0,0l-2.2-6.3 c-0.4-1.2,0.2-2.6,1.5-3.1C151.9,1247.9,153.3,1248.5,153.8,1249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M161.7,1270.3l2.7,6.1c0.5,1.2,0,2.7-1.2,3.2c-1.2,0.5-2.7,0-3.2-1.2l0,0l-2.7-6.1c-0.5-1.2,0-2.7,1.2-3.2 C159.7,1268.5,161.2,1269.1,161.7,1270.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M171.1,1290.2l3.1,5.9c0.6,1.2,0.2,2.7-1,3.3s-2.7,0.2-3.3-1l0,0l-3.1-5.9c-0.6-1.2-0.2-2.7,1-3.3 C169,1288.5,170.5,1289,171.1,1290.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M181.8,1309.4l3.5,5.7c0.7,1.2,0.4,2.7-0.8,3.4s-2.7,0.4-3.4-0.8l0,0l-3.5-5.7c-0.7-1.2-0.4-2.7,0.8-3.4 C179.6,1307.9,181.1,1308.2,181.8,1309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M193.9,1327.8l3.9,5.4c0.8,1.1,0.6,2.7-0.6,3.5c-1.1,0.8-2.7,0.6-3.5-0.6l0,0l-3.9-5.4 c-0.8-1.1-0.5-2.7,0.6-3.5C191.5,1326.5,193.1,1326.7,193.9,1327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M207.1,1345.4l4.2,5.1c0.9,1.1,0.7,2.7-0.3,3.5c-1.1,0.9-2.6,0.7-3.5-0.3l0,0l-4.2-5.2 c-0.9-1.1-0.7-2.7,0.4-3.5C204.7,1344.2,206.2,1344.3,207.1,1345.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M221.5,1362.1l4.6,4.8c1,1,0.9,2.6-0.1,3.6s-2.6,0.9-3.6-0.1l0,0l-4.6-4.9c-0.9-1-0.9-2.6,0.1-3.6 C219,1361,220.6,1361.1,221.5,1362.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M236.9,1377.8l4.9,4.5c1,1,1.1,2.6,0.1,3.6c-1,1-2.6,1.1-3.6,0.1l0,0l-4.9-4.6c-1-1-1.1-2.6-0.1-3.6 C234.3,1376.9,235.9,1376.8,236.9,1377.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M253.4,1392.4l5.2,4.2c1.1,0.9,1.3,2.5,0.4,3.6c-0.9,1.1-2.5,1.3-3.6,0.4l0,0l-5.1-4.2 c-1.1-0.9-1.3-2.5-0.4-3.6C250.7,1391.7,252.3,1391.5,253.4,1392.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M270.8,1405.9l5.4,3.8c1.2,0.8,1.4,2.4,0.6,3.6s-2.5,1.4-3.6,0.6l0,0l-5.4-3.9c-1.2-0.8-1.4-2.4-0.6-3.6 C268,1405.4,269.6,1405.1,270.8,1405.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M289,1418.2l5.7,3.5c1.2,0.8,1.6,2.4,0.9,3.6c-0.8,1.2-2.4,1.6-3.6,0.9l0,0l-5.7-3.5 c-1.2-0.8-1.6-2.4-0.9-3.6C286.2,1417.9,287.8,1417.5,289,1418.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M308,1429.3l5.9,3.1c1.3,0.7,1.8,2.3,1.1,3.6s-2.3,1.8-3.5,1.1l0,0l-5.9-3.1c-1.3-0.7-1.8-2.3-1.1-3.5 C305.2,1429.1,306.7,1428.6,308,1429.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327.8,1439l6.1,2.7c1.3,0.6,2,2.2,1.4,3.5c-0.6,1.3-2.1,1.9-3.5,1.4l0,0l-6.1-2.7c-1.3-0.6-1.9-2.2-1.4-3.5 C324.9,1439,326.4,1438.4,327.8,1439z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M348.1,1447.3l6.2,2.3c1.4,0.5,2.1,2,1.6,3.4c-0.5,1.4-2,2.1-3.4,1.6l0,0l-6.2-2.3c-1.4-0.5-2.1-2-1.6-3.4 C345.2,1447.6,346.8,1446.8,348.1,1447.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369,1454.4l6.4,1.9c1.4,0.4,2.2,1.9,1.8,3.3c-0.4,1.4-1.9,2.2-3.3,1.8l0,0l-6.4-1.9 c-1.4-0.4-2.2-1.9-1.8-3.3S367.5,1454,369,1454.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M390.2,1460.2l6.5,1.5c1.5,0.3,2.4,1.8,2,3.2s-1.8,2.4-3.2,2l0,0l-6.5-1.5c-1.5-0.3-2.4-1.8-2-3.2 C387.3,1460.7,388.8,1459.8,390.2,1460.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M411.8,1464.6l6.6,1.1c1.5,0.2,2.5,1.7,2.2,3.1c-0.2,1.5-1.6,2.5-3.1,2.2l0,0l-6.6-1.1 c-1.5-0.2-2.5-1.7-2.2-3.1S410.3,1464.4,411.8,1464.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M433.6,1467.8l6.6,0.7c1.5,0.2,2.6,1.5,2.4,3s-1.5,2.6-3,2.4h0l-6.6-0.7c-1.5-0.2-2.6-1.5-2.4-3 C430.7,1468.7,432.1,1467.6,433.6,1467.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M455.5,1469.7l6.6,0.3c1.5,0.1,2.7,1.4,2.6,2.9s-1.4,2.7-2.9,2.6h0l-6.6-0.3c-1.5-0.1-2.7-1.4-2.6-2.9 C452.7,1470.8,454,1469.6,455.5,1469.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M477.5,1470.3l6.6,0c1.5,0,2.8,1.2,2.8,2.8c0,1.5-1.2,2.8-2.8,2.8h0l-6.6,0c-1.5,0-2.8-1.2-2.8-2.8 C474.8,1471.6,476,1470.4,477.5,1470.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M499.6,1469.8l6.6-0.4c1.5-0.1,2.9,1.1,3,2.6c0.1,1.6-1.1,2.9-2.6,3h0l-6.6,0.4c-1.5,0.1-2.9-1.1-3-2.6 S498,1469.9,499.6,1469.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M521.5,1468.1l6.6-0.8c1.5-0.2,2.9,0.9,3.1,2.5c0.2,1.6-0.9,2.9-2.5,3.1l0,0l-6.6,0.8 c-1.5,0.2-2.9-0.9-3.1-2.5C518.9,1469.6,520,1468.2,521.5,1468.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M543.4,1465.2l6.6-1.1c1.5-0.3,3,0.8,3.2,2.3c0.3,1.5-0.8,3-2.3,3.2l0,0l-6.6,1.1c-1.5,0.3-3-0.8-3.2-2.3 C540.8,1466.9,541.8,1465.4,543.4,1465.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M565,1461.1l6.5-1.4c1.5-0.3,3,0.6,3.4,2.1c0.3,1.5-0.6,3-2.1,3.4l0,0l-6.5,1.4c-1.5,0.3-3-0.6-3.4-2.1 C562.5,1463,563.5,1461.4,565,1461.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M586.4,1455.9l6.4-1.8c1.5-0.4,3.1,0.5,3.5,2c0.4,1.5-0.5,3.1-2,3.5l0,0l-6.4,1.8c-1.5,0.4-3.1-0.5-3.5-2 C584,1457.9,584.9,1456.3,586.4,1455.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M607.5,1449.6l6.3-2.1c1.5-0.5,3.1,0.3,3.6,1.8s-0.3,3.1-1.8,3.6l0,0l-6.3,2.1c-1.5,0.5-3.1-0.3-3.6-1.8 C605.3,1451.7,606.1,1450.1,607.5,1449.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M628.3,1442.2l6.2-2.5c1.5-0.6,3.1,0.1,3.7,1.6s-0.1,3.1-1.6,3.7l0,0l-6.2,2.5c-1.5,0.6-3.1-0.1-3.7-1.6 S626.8,1442.7,628.3,1442.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M648.6,1433.6l6-2.8c1.4-0.7,3.1,0,3.8,1.4c0.7,1.4,0,3.1-1.4,3.8l0,0l-6,2.8c-1.4,0.7-3.1,0-3.8-1.4 C646.5,1436,647.2,1434.3,648.6,1433.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M668.5,1424.1l5.9-3.1c1.4-0.7,3.1-0.2,3.8,1.2c0.7,1.4,0.2,3.1-1.2,3.8l0,0l-5.9,3.1 c-1.4,0.7-3.1,0.2-3.8-1.2C666.5,1426.5,667.1,1424.8,668.5,1424.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M687.9,1413.6l5.8-3.3c1.4-0.8,3.1-0.3,3.9,1.1c0.8,1.4,0.3,3.1-1,3.9l0,0l-5.8,3.3 c-1.4,0.8-3.1,0.3-3.9-1.1C686.1,1416.2,686.5,1414.4,687.9,1413.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M706.8,1402.3l5.6-3.6c1.3-0.8,3.1-0.4,3.9,0.9c0.8,1.3,0.5,3.1-0.9,3.9l0,0l-5.6,3.6 c-1.3,0.8-3.1,0.4-3.9-0.9C705.1,1404.9,705.5,1403.2,706.8,1402.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M725.3,1390.2l5.5-3.8c1.3-0.9,3.1-0.6,4,0.7c0.9,1.3,0.6,3.1-0.7,4l0,0l-5.5,3.8c-1.3,0.9-3.1,0.6-4-0.7 C723.7,1392.9,724,1391.1,725.3,1390.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M743.2,1377.4l5.3-4c1.3-0.9,3.1-0.7,4,0.6c1,1.3,0.7,3.1-0.6,4l0,0l-5.3,4c-1.3,0.9-3.1,0.7-4-0.6 C741.7,1380.2,742,1378.4,743.2,1377.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M760.8,1363.9l5.2-4.2c1.2-1,3-0.8,4,0.4c1,1.2,0.8,3-0.4,4l0,0l-5.2,4.2c-1.2,1-3,0.8-4-0.4 C759.3,1366.7,759.5,1364.9,760.8,1363.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M777.8,1349.9l5-4.3c1.2-1,3-0.9,4,0.3c1,1.2,0.9,3-0.3,4.1l0,0l-5,4.3c-1.2,1-3,0.9-4-0.3 C776.5,1352.8,776.6,1350.9,777.8,1349.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M794.5,1335.3l4.9-4.5c1.2-1.1,3-1,4.1,0.2c1.1,1.2,1,3-0.2,4.1l0,0l-4.9,4.5c-1.2,1.1-3,1-4.1-0.2 S793.3,1336.4,794.5,1335.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M810.7,1320.4l4.8-4.6c1.2-1.1,3-1.1,4.1,0.1c1.1,1.2,1,3-0.1,4.1l0,0l-4.8,4.6c-1.2,1.1-3,1.1-4.1-0.1 S809.5,1321.4,810.7,1320.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M826.6,1305l4.7-4.7c1.1-1.1,3-1.1,4.1,0c1.1,1.1,1.1,3,0,4.1l0,0l-4.7,4.7c-1.1,1.1-3,1.1-4.1,0 C825.5,1307.9,825.5,1306.1,826.6,1305z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M842.2,1289.3l4.6-4.8c1.1-1.2,2.9-1.2,4.1-0.1c1.2,1.1,1.2,2.9,0.1,4.1l0,0l-4.6,4.8 c-1.1,1.2-2.9,1.2-4.1,0.1C841.1,1292.2,841.1,1290.4,842.2,1289.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M857.5,1273.3l4.6-4.8c1.1-1.2,2.9-1.2,4.1-0.1c1.2,1.1,1.2,2.9,0.1,4.1l0,0l-4.6,4.8 c-1.1,1.2-2.9,1.2-4.1,0.1C856.5,1276.3,856.4,1274.5,857.5,1273.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M872.6,1257.1l4.5-4.9c1.1-1.2,2.9-1.3,4.1-0.2s1.3,2.9,0.2,4.1l0,0l-4.5,4.9c-1.1,1.2-2.9,1.3-4.1,0.2 C871.6,1260.1,871.5,1258.3,872.6,1257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M887.5,1240.7l4.5-4.9c1.1-1.2,2.9-1.3,4.1-0.2c1.2,1.1,1.3,2.9,0.2,4.1l0,0l-4.5,4.9 c-1.1,1.2-2.9,1.3-4.1,0.2C886.5,1243.7,886.5,1241.9,887.5,1240.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M902.3,1224.2l4.4-5c1.1-1.2,2.9-1.3,4.1-0.2c1.2,1.1,1.3,2.9,0.2,4.1l0,0l-4.4,5c-1.1,1.2-2.9,1.3-4.1,0.2 C901.3,1227.2,901.2,1225.4,902.3,1224.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M917,1207.6l4.4-5c1.1-1.2,2.9-1.3,4.1-0.3c1.2,1.1,1.3,2.9,0.3,4.1l0,0l-4.4,5c-1.1,1.2-2.9,1.3-4.1,0.3 C916,1210.6,915.9,1208.8,917,1207.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M931.6,1190.9l4.4-5c1.1-1.2,2.9-1.3,4.1-0.3c1.2,1.1,1.3,2.9,0.3,4.1l0,0l-4.4,5c-1.1,1.2-2.9,1.3-4.1,0.3 C930.7,1194,930.5,1192.1,931.6,1190.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M946.2,1174.2l4.4-5c1.1-1.2,2.9-1.3,4.1-0.3c1.2,1.1,1.3,2.9,0.3,4.1l0,0l-4.4,5c-1.1,1.2-2.9,1.3-4.1,0.3 C945.3,1177.3,945.2,1175.4,946.2,1174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M960.9,1157.6l4.4-5c1.1-1.2,2.9-1.3,4.1-0.2c1.2,1.1,1.3,2.9,0.2,4.1l0,0l-4.4,5c-1.1,1.2-2.9,1.3-4.1,0.2 C959.9,1160.6,959.8,1158.8,960.9,1157.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M975.6,1140.9l4.4-5c1.1-1.2,2.9-1.3,4.1-0.2c1.2,1.1,1.3,2.9,0.2,4.1l0,0l-4.4,5c-1.1,1.2-2.9,1.3-4.1,0.2 C974.6,1144,974.5,1142.2,975.6,1140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M990.5,1124.4l4.5-4.9c1.1-1.2,3-1.3,4.2-0.2c1.2,1.1,1.3,2.9,0.2,4.2l0,0l-4.5,4.9c-1.1,1.2-3,1.3-4.2,0.2 C989.5,1127.5,989.4,1125.6,990.5,1124.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1005.5,1108.1l4.5-4.9c1.1-1.2,3-1.2,4.2-0.1s1.2,3,0.1,4.2l0,0l-4.5,4.9c-1.1,1.2-3,1.2-4.2,0.1 C1004.5,1111.1,1004.4,1109.3,1005.5,1108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1020.8,1091.9l4.6-4.8c1.1-1.2,3-1.2,4.2-0.1c1.2,1.1,1.2,3,0.1,4.2l0,0l-4.6,4.8c-1.1,1.2-3,1.2-4.2,0.1 C1019.7,1094.9,1019.6,1093.1,1020.8,1091.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1036.2,1075.9l4.7-4.7c1.2-1.2,3-1.2,4.2,0c1.2,1.2,1.2,3,0,4.2l0,0l-4.7,4.7c-1.2,1.2-3,1.2-4.2,0 C1035.1,1079,1035.1,1077.1,1036.2,1075.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1052,1060.3l4.8-4.6c1.2-1.1,3.1-1.1,4.2,0.1c1.1,1.2,1.1,3.1-0.1,4.2l0,0l-4.8,4.6c-1.2,1.1-3,1.1-4.2-0.1 S1050.8,1061.4,1052,1060.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1068.1,1044.9l4.9-4.5c1.2-1.1,3.1-1,4.2,0.2c1.1,1.2,1,3.1-0.2,4.2l0,0l-4.9,4.5c-1.2,1.1-3.1,1-4.2-0.2 C1066.8,1047.9,1066.9,1046,1068.1,1044.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1084.6,1030l5-4.4c1.2-1.1,3.1-1,4.2,0.3c1.1,1.2,1,3.1-0.3,4.2l0,0l-5,4.4c-1.2,1.1-3.1,1-4.2-0.3 C1083.2,1032.9,1083.4,1031,1084.6,1030z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1101.5,1015.4l5.1-4.2c1.3-1,3.1-0.9,4.2,0.4c1.1,1.3,0.9,3.1-0.4,4.2l0,0l-5.1,4.2c-1.3,1-3.1,0.9-4.2-0.4 C1100,1018.3,1100.2,1016.5,1101.5,1015.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1118.8,1001.4l5.3-4.1c1.3-1,3.2-0.8,4.2,0.5c1,1.3,0.8,3.2-0.5,4.2l0,0l-5.3,4.1c-1.3,1-3.2,0.8-4.2-0.5 C1117.3,1004.3,1117.5,1002.4,1118.8,1001.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1136.6,988l5.4-3.9c1.3-1,3.2-0.7,4.2,0.7c1,1.3,0.7,3.2-0.7,4.2l0,0l-5.4,3.9c-1.3,1-3.2,0.7-4.2-0.7 C1134.9,990.8,1135.2,988.9,1136.6,988z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1154.8,975.1l5.5-3.7c1.4-0.9,3.2-0.5,4.1,0.8c0.9,1.4,0.5,3.2-0.8,4.1l0,0l-5.5,3.7 c-1.4,0.9-3.2,0.5-4.1-0.8C1153.1,977.9,1153.4,976,1154.8,975.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1173.5,963l5.7-3.5c1.4-0.9,3.2-0.4,4.1,1s0.4,3.2-1,4.1l0,0l-5.7,3.5c-1.4,0.9-3.2,0.4-4.1-1 C1171.7,965.7,1172.1,963.9,1173.5,963z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1192.7,951.7l5.8-3.2c1.4-0.8,3.3-0.3,4.1,1.2c0.8,1.4,0.3,3.3-1.2,4.1l0,0l-5.8,3.2 c-1.4,0.8-3.3,0.3-4.1-1.2C1190.8,954.3,1191.3,952.5,1192.7,951.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1212.4,941.1l5.9-3c1.5-0.8,3.3-0.2,4,1.3s0.2,3.3-1.3,4l0,0l-5.9,3c-1.5,0.8-3.3,0.2-4-1.3 C1210.3,943.7,1210.9,941.9,1212.4,941.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1232.4,931.3l6-2.8c1.5-0.7,3.3,0,4,1.5c0.7,1.5,0,3.3-1.5,4l0,0l-6.1,2.8c-1.5,0.7-3.3,0-4-1.5 C1230.2,933.8,1230.9,932,1232.4,931.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1252.8,922.2l6.1-2.6c1.5-0.6,3.3,0.1,3.9,1.6c0.6,1.5-0.1,3.3-1.6,3.9l0,0l-6.2,2.5 c-1.5,0.6-3.3-0.1-3.9-1.6C1250.5,924.6,1251.2,922.9,1252.8,922.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1273.4,913.9l6.2-2.3c1.6-0.6,3.3,0.2,3.9,1.8s-0.2,3.3-1.8,3.9l0,0l-6.2,2.3c-1.6,0.6-3.3-0.2-3.9-1.8 C1271.1,916.2,1271.9,914.5,1273.4,913.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1294.4,906.4l6.3-2.1c1.6-0.5,3.3,0.3,3.8,1.9c0.5,1.6-0.3,3.3-1.9,3.8l0,0l-6.3,2.1 c-1.6,0.5-3.3-0.3-3.8-1.9S1292.8,906.9,1294.4,906.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1315.7,899.7l6.4-1.9c1.6-0.5,3.3,0.5,3.8,2s-0.4,3.3-2.1,3.8l0,0l-6.4,1.9c-1.6,0.5-3.3-0.5-3.7-2 C1313.2,901.8,1314.1,900.1,1315.7,899.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1337.2,893.7l6.4-1.6c1.6-0.4,3.3,0.6,3.7,2.2c0.4,1.6-0.6,3.3-2.2,3.7l0,0l-6.4,1.6 c-1.6,0.4-3.3-0.6-3.7-2.2C1334.6,895.7,1335.5,894.1,1337.2,893.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1358.8,888.5l6.5-1.4c1.6-0.3,3.2,0.7,3.6,2.3c0.3,1.6-0.7,3.2-2.3,3.6l0,0l-6.5,1.4 c-1.6,0.3-3.2-0.7-3.6-2.3S1357.2,888.8,1358.8,888.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1380.7,884l6.6-1.2c1.7-0.3,3.2,0.8,3.5,2.5c0.3,1.7-0.8,3.2-2.4,3.5l0,0l-6.6,1.2 c-1.7,0.3-3.2-0.8-3.5-2.5C1377.9,885.9,1379,884.3,1380.7,884z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1402.6,880.3l6.6-1c1.7-0.2,3.2,0.9,3.4,2.6c0.2,1.7-0.9,3.2-2.6,3.4l0,0l-6.6,1c-1.7,0.2-3.2-0.9-3.4-2.6 C1399.8,882.1,1401,880.6,1402.6,880.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1424.7,877.4l6.6-0.7c1.7-0.2,3.2,1,3.3,2.7c0.2,1.7-1,3.2-2.7,3.3l0,0l-6.6,0.7c-1.7,0.2-3.2-1-3.3-2.7 C1421.9,879.1,1423.1,877.6,1424.7,877.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1446.9,875.3l6.6-0.5c1.7-0.1,3.1,1.1,3.3,2.8c0.1,1.7-1.1,3.1-2.8,3.3l0,0l-6.6,0.5 c-1.7,0.1-3.1-1.1-3.3-2.8C1444,876.9,1445.2,875.4,1446.9,875.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1469.2,873.9l6.7-0.3c1.7-0.1,3.1,1.2,3.2,2.9c0.1,1.7-1.2,3.1-2.9,3.2l0,0l-6.7,0.3 c-1.7,0.1-3.1-1.2-3.2-2.9C1466.2,875.4,1467.5,874,1469.2,873.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1491.4,873.3l6.7,0c1.7,0,3.1,1.3,3.1,3c0,1.7-1.3,3.1-3,3.1l0,0l-6.7,0c-1.7,0-3.1-1.3-3.1-3 S1489.8,873.3,1491.4,873.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1513.7,873.5l6.7,0.2c1.7,0,3,1.5,3,3.2s-1.5,3-3.2,3l0,0l-6.7-0.2c-1.7,0-3-1.5-3-3.2 C1510.6,874.7,1512.1,873.4,1513.7,873.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1536,874.4l6.6,0.4c1.7,0.1,3,1.6,2.9,3.3s-1.6,3-3.3,2.9l0,0l-6.6-0.4c-1.7-0.1-3-1.6-2.9-3.3 S1534.3,874.3,1536,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1558.2,876.1l6.6,0.7c1.7,0.2,2.9,1.7,2.8,3.4s-1.7,2.9-3.4,2.8l0,0l-6.6-0.7c-1.7-0.2-2.9-1.7-2.8-3.4 S1556.6,875.9,1558.2,876.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1580.4,878.6l6.6,0.9c1.7,0.2,2.9,1.8,2.6,3.5s-1.8,2.9-3.5,2.6l0,0l-6.6-0.9c-1.7-0.2-2.9-1.8-2.6-3.5 S1578.7,878.3,1580.4,878.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1602.4,881.8l6.6,1.1c1.7,0.3,2.8,1.9,2.5,3.5c-0.3,1.7-1.9,2.8-3.6,2.5l0,0l-6.6-1.1 c-1.7-0.3-2.8-1.9-2.5-3.5C1599.2,882.7,1600.8,881.5,1602.4,881.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1624.4,885.9l6.5,1.4c1.7,0.3,2.7,2,2.4,3.7c-0.3,1.7-2,2.7-3.7,2.4l0,0l-6.5-1.4c-1.7-0.3-2.7-2-2.4-3.7 C1621.1,886.6,1622.7,885.5,1624.4,885.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1646.1,890.7l6.5,1.6c1.7,0.4,2.7,2.1,2.3,3.7s-2.1,2.7-3.7,2.3l0,0l-6.5-1.6c-1.7-0.4-2.7-2.1-2.3-3.7 C1642.8,891.3,1644.5,890.3,1646.1,890.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1667.7,896.3l6.4,1.8c1.6,0.5,2.6,2.2,2.1,3.8c-0.5,1.6-2.2,2.6-3.8,2.1l0,0l-6.4-1.8 c-1.6-0.5-2.6-2.2-2.1-3.8C1664.4,896.8,1666.1,895.8,1667.7,896.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1689.1,902.7l6.3,2.1c1.6,0.5,2.5,2.3,2,3.9c-0.5,1.6-2.3,2.5-3.9,2l0,0l-6.3-2.1c-1.6-0.5-2.5-2.3-2-3.9 C1685.7,903,1687.4,902.1,1689.1,902.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1710.2,909.8l6.2,2.3c1.6,0.6,2.4,2.4,1.8,4c-0.6,1.6-2.4,2.4-4,1.8l0,0l-6.2-2.3c-1.6-0.6-2.4-2.4-1.8-4 C1706.8,910.1,1708.6,909.2,1710.2,909.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1731,917.8l6.2,2.5c1.6,0.7,2.3,2.5,1.7,4c-0.7,1.6-2.5,2.3-4.1,1.7l0,0l-6.2-2.5c-1.6-0.7-2.3-2.5-1.7-4 C1727.6,917.9,1729.4,917.1,1731,917.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1751.6,926.5l6.1,2.8c1.6,0.7,2.2,2.6,1.5,4.1s-2.6,2.2-4.1,1.5l0,0l-6.1-2.8c-1.6-0.7-2.2-2.6-1.5-4.1 S1750,925.8,1751.6,926.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1771.7,936l5.9,3c1.5,0.8,2.2,2.6,1.4,4.2c-0.8,1.5-2.6,2.2-4.2,1.4l0,0l-5.9-3c-1.5-0.8-2.2-2.6-1.4-4.2 C1768.3,935.9,1770.2,935.2,1771.7,936z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1791.5,946.3l5.8,3.2c1.5,0.8,2.1,2.7,1.2,4.2c-0.8,1.5-2.7,2-4.2,1.2l0,0l-5.8-3.2 c-1.5-0.8-2.1-2.7-1.2-4.2C1788.1,946,1790,945.5,1791.5,946.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1810.9,957.4l5.7,3.5c1.5,0.9,1.9,2.8,1.1,4.3c-0.9,1.5-2.8,2-4.3,1l0,0l-5.7-3.5c-1.5-0.9-1.9-2.8-1.1-4.3 C1807.5,957,1809.4,956.5,1810.9,957.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1829.8,969.2l5.6,3.7c1.4,1,1.8,2.9,0.9,4.3s-2.9,1.8-4.3,0.9l0,0l-5.6-3.7c-1.4-1-1.8-2.9-0.9-4.3 C1826.4,968.6,1828.3,968.2,1829.8,969.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1848.3,981.5l5.5,3.8c1.4,1,1.8,2.9,0.8,4.4c-1,1.4-2.9,1.8-4.4,0.8l0,0l-5.5-3.8c-1.4-1-1.8-2.9-0.8-4.4 C1844.9,980.9,1846.9,980.6,1848.3,981.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1866.5,994.3l5.4,3.9c1.4,1,1.7,3,0.7,4.4c-1,1.4-3,1.7-4.4,0.7l0,0l-5.4-3.9c-1.4-1-1.7-3-0.7-4.4 C1863.2,993.6,1865.1,993.3,1866.5,994.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1884.6,1007.2l5.4,3.9c1.4,1,1.7,3,0.7,4.4c-1,1.4-3,1.7-4.4,0.7l0,0l-5.4-3.9c-1.4-1-1.7-3-0.7-4.4 C1881.2,1006.5,1883.2,1006.2,1884.6,1007.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1902.5,1020.2l5.4,3.9c1.4,1,1.7,3,0.7,4.4s-3,1.7-4.4,0.7l0,0l-5.4-3.9c-1.4-1-1.7-3-0.7-4.4 C1899.2,1019.5,1901.1,1019.2,1902.5,1020.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1920.6,1033.1l5.4,3.8c1.4,1,1.8,3,0.8,4.4s-3,1.8-4.4,0.8l0,0l-5.4-3.8c-1.4-1-1.8-3-0.8-4.4 C1917.2,1032.4,1919.1,1032.1,1920.6,1033.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1938.7,1045.7l5.5,3.7c1.4,1,1.8,2.9,0.8,4.4c-1,1.4-2.9,1.8-4.4,0.8l0,0l-5.5-3.7c-1.4-1-1.8-2.9-0.8-4.4 C1935.3,1045.1,1937.3,1044.7,1938.7,1045.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1957.1,1057.9l5.6,3.6c1.5,0.9,1.9,2.9,1,4.4c-0.9,1.5-2.9,1.9-4.4,1l0,0l-5.6-3.6c-1.5-0.9-1.9-2.9-1-4.4 S1955.7,1057,1957.1,1057.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1975.9,1069.6l5.7,3.4c1.5,0.9,2,2.8,1.1,4.3c-0.9,1.5-2.8,2-4.3,1.1l0,0l-5.7-3.4c-1.5-0.9-2-2.8-1.1-4.3 C1972.4,1069.2,1974.4,1068.7,1975.9,1069.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1995.1,1080.4l5.9,3.1c1.6,0.8,2.2,2.7,1.3,4.3c-0.8,1.6-2.7,2.2-4.3,1.3l0,0l-5.9-3.1 c-1.6-0.8-2.2-2.7-1.3-4.3C1991.6,1080.2,1993.5,1079.6,1995.1,1080.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2014.8,1090.2l6.1,2.7c1.6,0.7,2.3,2.6,1.6,4.2c-0.7,1.6-2.6,2.3-4.2,1.6l0,0l-6.1-2.7 c-1.6-0.7-2.3-2.6-1.6-4.2C2011.3,1090.2,2013.2,1089.5,2014.8,1090.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2035,1098.7l6.2,2.3c1.7,0.6,2.5,2.4,1.9,4.1c-0.6,1.7-2.4,2.5-4.1,1.9l0,0l-6.2-2.3 c-1.7-0.6-2.5-2.4-1.9-4.1C2031.5,1098.9,2033.4,1098.1,2035,1098.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2055.8,1105.7l6.4,1.8c1.7,0.5,2.7,2.2,2.2,3.9c-0.5,1.7-2.2,2.7-3.9,2.2l0,0l-6.4-1.8 c-1.7-0.5-2.7-2.2-2.2-3.9C2052.3,1106.2,2054.1,1105.3,2055.8,1105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2077,1111l6.5,1.2c1.7,0.3,2.9,2,2.6,3.7c-0.3,1.7-2,2.9-3.7,2.6l0,0l-6.5-1.2c-1.7-0.3-2.9-2-2.6-3.7 C2073.6,1111.8,2075.3,1110.6,2077,1111z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2098.7,1114.2l6.6,0.6c1.8,0.2,3.1,1.7,2.9,3.4c-0.1,1.8-1.7,3.1-3.4,2.9l0,0l-6.6-0.6 c-1.8-0.2-3.1-1.7-2.9-3.4C2095.4,1115.3,2096.9,1114.1,2098.7,1114.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2120.5,1115.3l6.6-0.2c1.8,0,3.2,1.4,3.3,3.1s-1.4,3.2-3.1,3.3l0,0l-6.6,0.2c-1.8,0-3.2-1.4-3.3-3.1 C2117.3,1116.8,2118.7,1115.3,2120.5,1115.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2142.2,1113.9l6.6-0.9c1.8-0.2,3.4,1,3.6,2.8s-1,3.4-2.8,3.6l0,0l-6.6,0.9c-1.8,0.2-3.4-1-3.6-2.8 C2139.3,1115.8,2140.5,1114.2,2142.2,1113.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2163.8,1110.3l6.5-1.5c1.7-0.4,3.4,0.7,3.9,2.4c0.4,1.7-0.6,3.4-2.4,3.9l0,0l-6.5,1.5 c-1.7,0.4-3.4-0.7-3.9-2.4C2161,1112.5,2162.1,1110.7,2163.8,1110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2184.9,1104.5l6.3-2.2c1.7-0.6,3.5,0.3,4.1,2c0.6,1.7-0.3,3.5-2,4.1l0,0l-6.3,2.2c-1.7,0.6-3.5-0.3-4.1-2 C2182.3,1106.9,2183.2,1105.1,2184.9,1104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2205.3,1096.7l6.1-2.8c1.6-0.7,3.5,0,4.3,1.6c0.7,1.6,0,3.5-1.6,4.3l0,0l-6.1,2.8c-1.6,0.7-3.5,0-4.2-1.6 C2203,1099.3,2203.7,1097.4,2205.3,1096.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2224.9,1087l5.8-3.3c1.6-0.9,3.5-0.3,4.4,1.2c0.9,1.6,0.3,3.5-1.2,4.4l0,0l-5.8,3.3 c-1.6,0.9-3.5,0.3-4.4-1.2C2222.8,1089.9,2223.4,1087.9,2224.9,1087z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2243.6,1075.7l5.5-3.8c1.5-1,3.5-0.6,4.5,0.8s0.6,3.5-0.8,4.5l0,0l-5.5,3.8c-1.5,1-3.5,0.6-4.5-0.8 C2241.8,1078.7,2242.2,1076.7,2243.6,1075.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2261.3,1062.7l5.1-4.2c1.4-1.1,3.4-0.9,4.5,0.4c1.1,1.4,0.9,3.4-0.4,4.5l0,0l-5.1,4.2 c-1.4,1.1-3.4,0.9-4.5-0.5C2259.7,1065.9,2259.9,1063.8,2261.3,1062.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2277.9,1048.4l4.8-4.6c1.3-1.2,3.3-1.2,4.6,0.1c1.2,1.3,1.2,3.3-0.1,4.6l0,0l-4.8,4.6 c-1.3,1.2-3.3,1.2-4.6-0.1C2276.6,1051.6,2276.6,1049.6,2277.9,1048.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2293.2,1032.7l4.4-5c1.2-1.3,3.2-1.5,4.6-0.3c1.3,1.2,1.5,3.2,0.3,4.6l0,0l-4.4,5c-1.2,1.3-3.2,1.5-4.6,0.3 C2292.2,1036.1,2292.1,1034.1,2293.2,1032.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2307.3,1015.9l4-5.3c1.1-1.4,3.1-1.7,4.5-0.6c1.4,1.1,1.7,3.1,0.6,4.5l0,0l-4,5.3c-1.1,1.4-3.1,1.7-4.5,0.6 C2306.5,1019.4,2306.2,1017.3,2307.3,1015.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2320,998l3.6-5.6c1-1.5,3-2,4.5-1c1.5,1,2,3,1,4.5l0,0l-3.6,5.6c-1,1.5-3,2-4.5,1S2319,999.5,2320,998z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2331.2,979.2l3.1-5.9c0.8-1.6,2.8-2.2,4.4-1.4c1.6,0.8,2.2,2.8,1.4,4.4l0,0l-3.1,5.9 c-0.8,1.6-2.8,2.2-4.4,1.4C2330.9,982.7,2330.3,980.8,2331.2,979.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2340.8,959.5l2.6-6.1c0.7-1.7,2.6-2.4,4.3-1.7c1.7,0.7,2.4,2.6,1.7,4.3l0,0l-2.6,6.1 c-0.7,1.7-2.6,2.4-4.3,1.7S2340.1,961.2,2340.8,959.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2348.6,939.1l2-6.3c0.6-1.7,2.4-2.7,4.1-2.1c1.7,0.5,2.7,2.4,2.1,4.1l0,0l-2,6.3c-0.6,1.7-2.4,2.7-4.1,2.1 C2349,942.6,2348.1,940.8,2348.6,939.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2354.8,918l1.5-6.5c0.4-1.8,2.2-2.8,3.9-2.4c1.8,0.4,2.8,2.2,2.4,3.9l0,0l-1.5,6.5 c-0.4,1.8-2.2,2.8-3.9,2.4C2355.4,921.5,2354.3,919.8,2354.8,918z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2359.2,896.5l1-6.6c0.3-1.8,1.9-3,3.7-2.7c1.8,0.3,3,2,2.7,3.7l0,0l-1,6.6c-0.3,1.8-1.9,3-3.7,2.7 C2360.1,900,2358.9,898.3,2359.2,896.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2362.1,874.8l0.6-6.6c0.1-1.8,1.7-3.1,3.5-3s3.1,1.7,3,3.5l0,0l-0.6,6.6c-0.1,1.8-1.7,3.1-3.5,3 C2363.3,878.2,2361.9,876.6,2362.1,874.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2363.4,852.9l0.1-6.7c0-1.8,1.5-3.3,3.3-3.2c1.8,0,3.3,1.5,3.2,3.3l0,0l-0.1,6.7c0,1.8-1.5,3.3-3.3,3.2 S2363.3,854.7,2363.4,852.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2363.1,830.9l-0.4-6.6c-0.1-1.8,1.3-3.4,3.1-3.5c1.8-0.1,3.4,1.3,3.4,3.1l0,0l0.4,6.6 c0.1,1.8-1.3,3.3-3.1,3.5C2364.8,834.1,2363.2,832.7,2363.1,830.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2361.4,809l-0.8-6.6c-0.2-1.8,1.1-3.4,2.9-3.7c1.8-0.2,3.4,1.1,3.6,2.9l0,0l0.8,6.6 c0.2,1.8-1.1,3.4-2.9,3.7C2363.3,812.1,2361.7,810.8,2361.4,809z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2358.4,787.3l-1.2-6.5c-0.3-1.8,0.9-3.5,2.6-3.8c1.8-0.3,3.5,0.9,3.8,2.7l0,0l1.2,6.5 c0.3,1.8-0.9,3.5-2.6,3.8C2360.4,790.2,2358.7,789.1,2358.4,787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2354,765.7l-1.6-6.5c-0.4-1.8,0.6-3.5,2.4-4c1.8-0.4,3.6,0.7,4,2.4l0,0l1.6,6.5c0.4,1.8-0.6,3.5-2.4,4 C2356.2,768.6,2354.4,767.5,2354,765.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2348.3,744.5l-2-6.4c-0.5-1.7,0.4-3.6,2.2-4.1c1.7-0.5,3.6,0.4,4.1,2.2l0,0l1.9,6.4 c0.5,1.7-0.4,3.6-2.2,4.1C2350.7,747.2,2348.8,746.2,2348.3,744.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2341.4,723.6l-2.3-6.2c-0.6-1.7,0.2-3.6,1.9-4.2s3.6,0.2,4.2,2l0,0l2.3,6.2c0.6,1.7-0.2,3.6-1.9,4.2 C2343.9,726.2,2342,725.3,2341.4,723.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2333.4,703.1l-2.6-6.1c-0.7-1.7,0-3.6,1.7-4.3s3.6,0,4.4,1.7l0,0l2.6,6.1c0.7,1.7-0.1,3.6-1.7,4.3 C2336.1,705.5,2334.1,704.8,2333.4,703.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2324.3,683.1l-3-6c-0.8-1.6-0.1-3.6,1.5-4.4c1.6-0.8,3.6-0.2,4.4,1.5l0,0l3,6c0.8,1.6,0.1,3.6-1.5,4.4 C2327.1,685.4,2325.1,684.7,2324.3,683.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2314.1,663.6l-3.3-5.8c-0.9-1.6-0.3-3.6,1.2-4.5s3.6-0.3,4.5,1.2l0,0l3.3,5.8c0.9,1.6,0.3,3.6-1.2,4.5 C2317,665.7,2315,665.2,2314.1,663.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2302.9,644.6l-3.6-5.6c-1-1.5-0.5-3.6,1-4.6c1.6-1,3.6-0.5,4.6,1l0,0l3.6,5.6c1,1.5,0.5,3.6-1,4.6 C2305.9,646.6,2303.9,646.2,2302.9,644.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2290.7,626.3l-3.9-5.4c-1.1-1.5-0.7-3.6,0.8-4.6s3.6-0.7,4.6,0.8l0,0l3.9,5.4c1.1,1.5,0.7,3.6-0.8,4.6 C2293.9,628.1,2291.8,627.8,2290.7,626.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2277.6,608.7l-4.2-5.2c-1.1-1.4-0.9-3.5,0.5-4.6s3.5-0.9,4.6,0.5l4.2,5.2c1.2,1.4,0.9,3.5-0.5,4.7 C2280.9,610.3,2278.8,610.1,2277.6,608.7L2277.6,608.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2263.4,591.9l-4.5-4.9c-1.2-1.3-1.1-3.4,0.2-4.6c1.3-1.2,3.4-1.1,4.6,0.2l4.5,4.9c1.2,1.3,1.1,3.4-0.2,4.6 C2266.7,593.3,2264.6,593.2,2263.4,591.9L2263.4,591.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2248.4,575.7l-4.7-4.8c-1.2-1.3-1.2-3.3,0.1-4.6c1.3-1.2,3.3-1.2,4.6,0l4.7,4.7c1.2,1.3,1.2,3.3,0,4.6 C2251.7,577,2249.6,577,2248.4,575.7L2248.4,575.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2232.7,560.1l-4.8-4.6c-1.3-1.2-1.3-3.2-0.1-4.5c1.2-1.3,3.2-1.3,4.5-0.1l4.8,4.6c1.3,1.2,1.3,3.2,0.1,4.5 C2236,561.3,2234,561.4,2232.7,560.1L2232.7,560.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2216.6,545l-4.9-4.5c-1.3-1.2-1.4-3.2-0.2-4.5c1.2-1.3,3.1-1.4,4.4-0.2l4.9,4.5c1.3,1.2,1.4,3.2,0.2,4.5 C2219.9,546.1,2217.9,546.2,2216.6,545L2216.6,545z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2200,530.2l-5-4.4c-1.3-1.1-1.4-3.1-0.3-4.4s3.1-1.5,4.4-0.3l5,4.3c1.3,1.1,1.4,3.1,0.3,4.4 S2201.3,531.3,2200,530.2L2200,530.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2183.2,515.8l-5.1-4.3c-1.3-1.1-1.5-3-0.4-4.3c1.1-1.3,3-1.5,4.3-0.4l5.1,4.2c1.3,1.1,1.5,3,0.4,4.3 C2186.5,516.7,2184.5,516.9,2183.2,515.8L2183.2,515.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2166.1,501.8l-5.2-4.2c-1.3-1-1.5-3-0.5-4.3s3-1.5,4.3-0.5l5.2,4.1c1.3,1,1.5,3,0.5,4.3 C2169.4,502.6,2167.4,502.8,2166.1,501.8L2166.1,501.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2148.8,488l-5.2-4.1c-1.3-1-1.5-2.9-0.5-4.2c1-1.3,2.9-1.5,4.2-0.5l5.3,4c1.3,1,1.6,2.9,0.6,4.2 S2150.1,489.1,2148.8,488L2148.8,488z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2131.2,474.5l-5.3-4c-1.3-1-1.5-2.8-0.6-4c0.9-1.3,2.7-1.5,4-0.6l5.4,4c1.3,1,1.6,2.8,0.6,4.1 C2134.4,475.2,2132.6,475.5,2131.2,474.5L2131.2,474.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2113.5,461.3l-5.4-3.9c-1.2-0.9-1.5-2.6-0.6-3.9c0.9-1.2,2.6-1.5,3.9-0.6l5.4,3.9c1.3,0.9,1.6,2.6,0.6,3.9 C2116.5,461.9,2114.8,462.2,2113.5,461.3L2113.5,461.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2095.5,448.3l-5.4-3.8c-1.2-0.9-1.5-2.5-0.6-3.7c0.8-1.2,2.5-1.5,3.7-0.6l5.5,3.8c1.2,0.9,1.5,2.5,0.7,3.8 S2096.8,449.2,2095.5,448.3L2095.5,448.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2077.4,435.6l-5.5-3.8c-1.2-0.8-1.5-2.4-0.7-3.5c0.8-1.2,2.4-1.5,3.5-0.7l5.5,3.7c1.2,0.8,1.5,2.4,0.7,3.6 S2078.6,436.5,2077.4,435.6L2077.4,435.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2059,423.2l-5.6-3.7c-1.1-0.8-1.4-2.3-0.7-3.4c0.7-1.1,2.2-1.4,3.4-0.7l5.6,3.6c1.1,0.7,1.5,2.3,0.7,3.4 S2060.2,424,2059,423.2L2059,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2040.5,411.1l-5.6-3.6c-1.1-0.7-1.4-2.1-0.7-3.2c0.7-1.1,2.1-1.4,3.2-0.7l5.7,3.5c1.1,0.7,1.5,2.2,0.8,3.3 C2043.1,411.5,2041.6,411.8,2040.5,411.1C2040.5,411.1,2040.5,411.1,2040.5,411.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2021.8,399.3l-5.7-3.5c-1-0.6-1.3-2-0.7-3c0.6-1,1.9-1.3,2.9-0.7l5.7,3.4c1.1,0.6,1.4,2,0.8,3 C2024.2,399.6,2022.8,399.9,2021.8,399.3C2021.8,399.3,2021.8,399.3,2021.8,399.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2002.8,387.8l-5.7-3.4c-0.9-0.6-1.3-1.8-0.7-2.7c0.6-0.9,1.8-1.3,2.7-0.7l5.8,3.3c1,0.6,1.3,1.8,0.8,2.8 C2005.1,388.1,2003.8,388.4,2002.8,387.8C2002.9,387.9,2002.8,387.8,2002.8,387.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1983.7,376.8l-5.8-3.2c-0.9-0.5-1.2-1.6-0.7-2.5c0.5-0.9,1.6-1.2,2.4-0.7l5.9,3.1c0.9,0.5,1.3,1.6,0.8,2.5 S1984.6,377.3,1983.7,376.8C1983.7,376.8,1983.7,376.8,1983.7,376.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1964.2,366.2l-5.9-3.1c-0.8-0.4-1.1-1.4-0.7-2.2c0.4-0.8,1.4-1.1,2.2-0.7l6,2.9c0.8,0.4,1.2,1.4,0.8,2.3 C1966.1,366.3,1965.1,366.6,1964.2,366.2C1964.2,366.2,1964.2,366.2,1964.2,366.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1944.4,356.3l-4.9-2.3c-0.7-0.3-1-1.2-0.7-1.9c0.3-0.7,1.2-1,1.8-0.7l5,2.2c0.7,0.3,1.1,1.2,0.7,1.9 S1945.2,356.6,1944.4,356.3C1944.5,356.3,1944.4,356.3,1944.4,356.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089540638713966433020000001436401934356442303_",
    gradientUnits: "userSpaceOnUse",
    x1: 1043.6066,
    y1: 663.4738,
    x2: 968.7549,
    y2: 571.4542,
    gradientTransform: "matrix(-1 0 0 -1 2098 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089540638713966433020000001436401934356442303_)"
    },
    d: "M1034.2,1036.1l18.5,58.8 c0,0,21.5,15.8,48.9,0.7c4.2-2.3,8.6-5.3,13-9.3c33.3-29.7,11.2-72.9,11.2-72.9s25.4-10.2,14.1-31.8c-0.8-1.5-2.9-1.2-3.4,0.4 c-1.6,6-5.7,16.3-14.1,20c-0.4,0.2-0.8,0.4-1.2,0.5c-0.4-1.1-0.4-2.5,0.5-3.9c2.6-4-2.1-9.4-2.1-9.4s-0.3,4.8-3.9,7.8 c-3.2,2.6-4.7,8.4-2.5,13.2c4.6,17.7,11.4,41-15.2,58.1c-2.7,1.7-5.5,2.8-8.4,3.3C1064.3,1075.8,1034.2,1036.1,1034.2,1036.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073708701002658491740000016682625409009255092_",
    gradientUnits: "userSpaceOnUse",
    x1: 1038.9244,
    y1: 565.1404,
    x2: 977.9245,
    y2: 525.1404,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073708701002658491740000016682625409009255092_)"
    },
    d: "M1034.2,1036.1l18.5,58.8 c0,0,21.5,15.8,48.9,0.7l-12-24C1064.3,1075.8,1034.2,1036.1,1034.2,1036.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032623919867311342470000000431535080779728828_",
    gradientUnits: "userSpaceOnUse",
    x1: 25223.7832,
    y1: 4274.6045,
    x2: 24802.0234,
    y2: 4196.9585,
    gradientTransform: "matrix(-0.9534 0.3019 -0.3019 -0.9534 -13396.2705 2446.6934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032623919867311342470000000431535080779728828_)"
    },
    d: "M1028.7,964c0,0,10.5-36.5-28.8-26.5 c0,0-19.2-2.7-19.8,15.4c0,0-8.3,12.5-8.7,28c0,0-37.8,9.8-43.8,24.9c-6.1,15.5-2.7,40.1,12.8,44.4c0,0-12.3,6.6-6.1,20.6 c6.2,14,36.4,23.3,53.7,5.7c0,0,50.5,5.5,48.6-30c0,0,23-15.7-2.2-44.5C1009.2,973.1,1028.7,964,1028.7,964z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083081480715413652940000006007335972085777308_",
    gradientUnits: "userSpaceOnUse",
    x1: 13750.1445,
    y1: 2195.7732,
    x2: 13735.1445,
    y2: 2307.7734,
    gradientTransform: "matrix(0.9922 -0.1247 -0.1247 -0.9922 -13050.3506 2356.7129)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083081480715413652940000006007335972085777308_)"
    },
    d: "M1031.8,1029.6 c-7.9-2.4-31-6.8-53,13.5c-3.7,3.4-5.2,8.7-3.9,13.6c5.9,21.7,21.5,85.9,7.8,113.7c0,0,24.1,26.5,50.3,5.2 c0,0,11.8-51.3,27.2-73.9c10.7-15.6-17-58.4-24-68.8C1035.1,1031.3,1033.6,1030.1,1031.8,1029.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148645086825305788710000018043316878240907394_",
    gradientUnits: "userSpaceOnUse",
    x1: 1019.7133,
    y1: 657.576,
    x2: 1004.2134,
    y2: 599.0759,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148645086825305788710000018043316878240907394_)"
    },
    d: "M1009.9,986.4 c0,0-11.7,33.2-12.6,47.8c0,0,13,5.9,25.2-4.1c0,0,1.3-33.2,3.1-39.1L1009.9,986.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156546499417988664060000000877171871370292618_",
    gradientUnits: "userSpaceOnUse",
    x1: -11464.5518,
    y1: -7152.5615,
    x2: -11501.5518,
    y2: -7095.5615,
    gradientTransform: "matrix(-0.9534 0.3019 -0.3019 -0.9534 -13396.2705 2446.6934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156546499417988664060000000877171871370292618_)"
    },
    d: "M1028.7,953.7 c0,0,31.7,42.2,13.6,55.1c-18.1,12.9-40.6-17.1-40.6-17.1s-7.7-23.3-0.4-31.5C1008.5,952,1028.7,953.7,1028.7,953.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125570943144982957870000012821917453020592570_",
    gradientUnits: "userSpaceOnUse",
    x1: -14097.9951,
    y1: -2842.2173,
    x2: -14175.9355,
    y2: -2934.8301,
    gradientTransform: "matrix(-0.9534 0.3019 -0.3019 -0.9534 -13396.2705 2446.6934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125570943144982957870000012821917453020592570_)"
    },
    d: "M1014.2,943.7c0,0,14.2,3,16.3,9.3 s-19.7,12.8-25.8,13.2l-4.3,25.8c0,0-15.2-23.9-9.8-38C996.1,940,1014.2,943.7,1014.2,943.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044178004746380277170000017615735750535582861_",
    gradientUnits: "userSpaceOnUse",
    x1: -11446.3594,
    y1: -7140.7627,
    x2: -11483.3594,
    y2: -7083.7627,
    gradientTransform: "matrix(-0.9534 0.3019 -0.3019 -0.9534 -13396.2705 2446.6934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044178004746380277170000017615735750535582861_)"
    },
    d: "M1007.6,988.4c0,0-12.3-13.5-16.8-4.4 s11.1,15.5,16.4,11L1007.6,988.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065770396892297121240000006560065733595322503_",
    gradientUnits: "userSpaceOnUse",
    x1: 13994.4736,
    y1: 7.0093,
    x2: 14136.1299,
    y2: 257.0627,
    gradientTransform: "matrix(1 -9.500000e-03 -9.500000e-03 -1 -13070.7725 1707.7046)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065770396892297121240000006560065733595322503_)"
    },
    d: "M1063.6,1283.3 c-0.1,2.3,4,20.8,6.2,30.7c0.9,4,0.3,8.1-1.8,11.7L991,1455.4c-0.9,1.6-1.6,3.3-2,5.1c-1.4,6.1-4.3,21-2.8,34.6l4,8.3 l-17.2-3.9l-3.8-46.3l4.9-3c4.2-2.6,7.5-6.4,9.4-11c7-16.9,24.3-60.1,28.8-81.1c5.1-23.9,31.6-43.3,31.6-43.3l-4.7-11 L1063.6,1283.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000191816779755692410000010891328066062826632_",
    gradientUnits: "userSpaceOnUse",
    x1: 977.1454,
    y1: 168.2085,
    x2: 915.1454,
    y2: 128.7085,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000191816779755692410000010891328066062826632_)"
    },
    d: "M953.7,1483.4c0,0,9.3-14.8,10.4-20.5 c1.1-5.8,4.2-15.9,9.9-12.8c0,0,2.7,27.9,1.8,38.8c-0.9,10.9,12.3,10.6,12.3,10.6s3.7,0.5,6.3,3.2c1.8,1.8,0.5,5.1-2.1,5.2 c-4.3,0.3-11.2,0.3-18.5-1.1c-2.5-0.5-4.4-2.6-4.6-5.2l-1.9-32.1l-11.8,14.8L953.7,1483.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067195650256194180470000001496709588977124771_",
    gradientUnits: "userSpaceOnUse",
    x1: 14154.9902,
    y1: 192.0016,
    x2: 13943.1387,
    y2: 124.2584,
    gradientTransform: "matrix(1 -9.500000e-03 -9.500000e-03 -1 -13070.7725 1707.7046)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067195650256194180470000001496709588977124771_)"
    },
    d: "M1017.5,1303.9 c0,0-2.7,116.1-3.1,132.6c-0.4,16.5,2.6,53,19.1,63.9l-7.2,5.3c0,0-9-7.6-17.8-22.3c-9.9-16.5-12.8-19.5-12.8-19.5l3.3-6.7 c1.4-2.9,1.8-6.2,1.2-9.4c-3.6-17.3-15.5-74.8-18.7-87.2c-3.8-14.6-4.1-34.1,9.2-50.5 C1004.1,1293.8,1017.5,1303.9,1017.5,1303.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044167555371971762060000015503236271828801711_",
    gradientUnits: "userSpaceOnUse",
    x1: 1069.2075,
    y1: 214.3079,
    x2: 1032.7074,
    y2: 178.8077,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044167555371971762060000015503236271828801711_)"
    },
    d: "M1002.3,1511c-0.5,0-1-0.4-1-0.9 c-0.5-3.9-2.8-19.4-4.7-23.4c-2.2-4.6-9.2-24,0-25.6c0,0,22.8,33.3,27.2,37.8c4.4,4.5,9.9,1.6,9.9,1.6s4.3,1.3,7.5,5.4 c1.5,1.9,0.1,4.8-2.4,4.8l-15.3,0.2c-4.5,0-8.5-2.7-10.1-6.8c-2.7-6.7-7.3-16.6-12.8-21l2.8,26.9 C1003.3,1510.5,1002.9,1511,1002.3,1511z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134948393461939061710000010905122288596429498_",
    gradientUnits: "userSpaceOnUse",
    x1: 14073.7744,
    y1: 281.4284,
    x2: 14128.5654,
    y2: 440.3227,
    gradientTransform: "matrix(1 -9.500000e-03 -9.500000e-03 -1 -13070.7725 1707.7046)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134948393461939061710000010905122288596429498_)"
    },
    d: "M1036.6,1163c0,0-3.5,11,1.8,29.2 l32.9,115c0.5,1.8-0.5,3.7-2.2,4.3c-9.8,3.5-42.2,13.5-86.5,10.5c-2.2-0.2-4.1-1.7-4.6-3.9c-2.9-13.1-12.9-57.9-14.9-67.1 c-7.8-35-16.5-72.8,21.8-95.7C1002.7,1162.9,1019.1,1167.4,1036.6,1163z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012471752503889857130000011389797676529051053_",
    gradientUnits: "userSpaceOnUse",
    x1: 989.7762,
    y1: 663.1237,
    x2: 1011.2761,
    y2: 712.1237,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012471752503889857130000011389797676529051053_)"
    },
    d: "M1036.7,956.8 c0,0-13.4-32.1-46.6-18.3s-19.3,37.9-19.3,37.9L1036.7,956.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072253519754080098230000011541614793693813397_",
    gradientUnits: "userSpaceOnUse",
    x1: 14381.8213,
    y1: -1481.8661,
    x2: 14447.3613,
    y2: -1520.9894,
    gradientTransform: "matrix(0.9525 -0.3047 -0.3047 -0.9525 -13166.7773 3909.698)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072253519754080098230000011541614793693813397_)"
    },
    d: "M973.2,950.1c0,0,41-24.8,54.4,9.3 c7.6-2.2,9-2.7,9-2.7s-11.9-30.6-34.4-23.7C979.7,939.9,974,943.8,973.2,950.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040540172066901458470000002327534489941498251_",
    gradientUnits: "userSpaceOnUse",
    x1: 967.5478,
    y1: 689.5697,
    x2: 1014.9263,
    y2: 689.5697,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040540172066901458470000002327534489941498251_)"
    },
    d: "M968,966.1c0,0,0.1,0,0.1,0 c3.7-1.3,6.9-2.4,10-3.6c2.2-0.8,4.4-1.8,6.5-2.8c3-1.4,6.2-2.9,9.3-3.7c6.5-1.8,15.1,4.4,20.2,8.1l0.2,0.2 c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5l-0.2-0.2c-5.3-3.8-14.1-10.1-20.9-8.2c-3.2,0.9-6.4,2.3-9.4,3.8 c-2.1,1-4.3,2-6.4,2.8c-3,1.1-6.3,2.3-10,3.5c-0.2,0.1-0.3,0.3-0.2,0.5C967.6,966,967.8,966.1,968,966.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079446883970498631610000003589521825674077568_",
    gradientUnits: "userSpaceOnUse",
    x1: 1005.0361,
    y1: 691.0002,
    x2: 1019.0362,
    y2: 650.0001,
    gradientTransform: "matrix(1 0 0 -1 0 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079446883970498631610000003589521825674077568_)"
    },
    d: "M970.3,981.2l77-18.7 c0.5-0.1,0.8-0.5,0.9-1c0.1-0.5-0.2-1-0.7-1.2c-3.6-1.7-9.7-4.2-12.3-3.4c-8.5,2.5-64.4,19.5-64.4,19.5 S969.4,976.8,970.3,981.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122690458190323006800000003532612761239139502_",
    gradientUnits: "userSpaceOnUse",
    x1: 1099.2798,
    y1: 837.064,
    x2: 1084.28,
    y2: 949.0637,
    gradientTransform: "matrix(-1 0 0 -1 2098 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122690458190323006800000003532612761239139502_)"
    },
    d: "M930.1,1118.5c0,0-0.2,0-0.2,0 c4.2-3.3,26.2-3.4,26.2-3.4s16-23.2,21.4-28.9c0.2-0.2,0.4-0.4,0.5-0.5c0.1-0.1,0.2-0.2,0.4-0.4c2-1.8,4.1-3.7,6.4-5.6 c2.5-2.1,4.5-4.8,5.8-7.8c8.5-21.3,1.8-35.3-13.6-26.3c0,0-32.6,27.1-45.2,65.4c-0.2,0.5-0.3,0.9-0.4,1.4c-0.5,1.8-1,3.5-1.5,5 c0,0.1,0.1,0.3,0.1,0.4C929.8,1118,930.2,1118.2,930.1,1118.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116201414186129421630000001387375570984628384_",
    gradientUnits: "userSpaceOnUse",
    x1: 3965.7795,
    y1: 512.6161,
    x2: 4052.9421,
    y2: 512.6161,
    gradientTransform: "matrix(1 0 0 -1 -3037.2822 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116201414186129421630000001387375570984628384_)"
    },
    d: "M1010.7,1132.4c0,0-37.9,21.4-50.6,3.1 c-2.7-3.8-4.6-16.8-4-20.4c-11.3-5.7-19.9,2.7-26.3,2.2c-1.7,8.8-2.5,17.3,2.7,26.7c22.4,40.9,83.2-2.3,83.2-2.3L1010.7,1132.4z "
  }), /*#__PURE__*/React.createElement("g", null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1006.1,1159.5l20.7-72.2c0.2-0.8,0.9-1.4,1.8-1.5c3.7-0.4,14.6-1.7,27.1-2.7c15.1-1.3,32.6-2.3,43.1-1.4 c1.5,0.1,2.4,1.7,1.7,3c-5.9,12-30.4,61-42.7,77.1c-0.4,0.5-1,0.8-1.7,0.8l-47.9-0.4 C1006.7,1162.2,1005.7,1160.8,1006.1,1159.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182499195612961879360000016106080911126776462_",
    gradientUnits: "userSpaceOnUse",
    x1: 4057.2356,
    y1: 907.7736,
    x2: 4042.2356,
    y2: 1019.7739,
    gradientTransform: "matrix(1 0 0 -1 -3037.2822 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182499195612961879360000016106080911126776462_)"
    },
    d: "M1057.8,1076.9l15-2.5 c0.8-0.1,1.4,0.6,1.2,1.4l-1.5,4.5c-0.1,0.4-0.5,0.7-0.9,0.7l-14.4,1.9c-0.8,0.1-1.4-0.6-1.2-1.3l0.9-3.9 C1057,1077.2,1057.4,1076.9,1057.8,1076.9z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1046.6,1089.5l1.2-6.4c0.1-0.6,0.7-1.1,1.3-1.2l30.3-3.1c1-0.1,1.8,0.8,1.6,1.8l-1.9,8 c-0.2,0.6-0.7,1.1-1.4,1.1l-29.6,1.5C1047.2,1091.4,1046.4,1090.5,1046.6,1089.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062152630114142460100000012060155284952393626_",
    gradientUnits: "userSpaceOnUse",
    x1: 4046.3867,
    y1: 520.1532,
    x2: 4073.9121,
    y2: 520.1532,
    gradientTransform: "matrix(1 0 0 -1 -3037.2822 1650)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062152630114142460100000012060155284952393626_)"
    },
    d: "M1011.1,1142.1c0,0-2.9-11.8-1.7-16 c1.2-4.2,3.4-9.6,10.9-8.4c7.5,1.2,16.3,4.4,16.3,4.4s-0.4,5.5-6.2,3.7l3.5,2.7c0,0-0.5,4.4-5.3,2l3.3,3.6c0,0-2.1,3.6-5.6,1.3 C1022.8,1133.1,1021.1,1143.5,1011.1,1142.1z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1935.6,294.4 1925.6,336.3 1901.5,311.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1752.8,225.8l89.7,126c1.7,2.4,4.3,4,7.3,4.5s5.9-0.3,8.3-2.1l123.1-94.8c1.4-1.1,2-2.9,1.5-4.6 c-0.5-1.7-1.9-3-3.7-3.2L1752.8,225.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1935.5,294.4 1752.8,225.8 1915.7,309.8 1913.4,321.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1903.9,318.8 1925.6,336.3 1915.7,309.8  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerandenergybremove);
export default __webpack_public_path__ + "static/media/powerandenergybremove.cef8ba66e97b077b88e305ec1f34aef0.svg";
export { ForwardRef as ReactComponent };